import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useInterval from "react-useinterval";
import { fixtureTime } from "../common/DateTimeHelper";
import { getRoundName } from "../common/RoundHelper";
import { formatStringCurrency } from "../common/CurrencyFormatter";
import useCouponShare from "../couponShares/useCouponShare";
import usePublicCouponShare from "../couponShares/usePublicCouponShare";
import { Fixture } from "../models/fixture";
import { DetailedRound } from "../models/round";
import useDetailRound from "../rounds/useDetailRound";
import useOutcomeTree from "../rounds/useOutcomeTree";
import { gradientsC, GetFlexNumber, IsRightToLeftTheme, themeC, IsShareCouponEnabled } from "../theme/themehelper";
import { getSurvivorThemeColors, getSurvivorThemeFlags } from "./survivortheme";
import CashoutButton from "../cashout/cashoutbutton";
import { CashoutConfirmDialog, CashoutResultDialog } from "../cashout/cashoutdialogs";
import useCashout from "../cashout/usecashout";
import { getTeamName } from "../slimcoupon/couponhelpers";
import { DbetEightIcon, DbetEightLadder, DbetSixIcon } from "../images/dbeticons";
import RechartChart from "./RechartChart";
import ShareDialog from "./sharedialog";
import WinInfo from "./wininfo";
import { getCurrentToken } from "../backend/fetchApi";
import { CouponShare } from "../models/couponshares";
import IosShareIcon from '@mui/icons-material/IosShare';
import { toPng } from 'html-to-image';
import { track } from '../analytics/analytics';
import unibet_football from '../images/unibet_football.jpg';
import hajper8 from '../images/hajper_8.png';
import snabbareSurvivorBg from '../images/snabbare_survivor_bg.png';
import hardSurvivor from '../images/hard_survivor_65.png';
import stuganBackground from '../images/stugan_background.png';
import woodRocket from '../images/wood_rocket.png';
import orangeRocket from '../images/orange_rocket.png';
import lionRocket from '../images/lion_rocket.png';
import { Unibet1x2TileLogo } from '../images/unibeticons';

const GoGoLogo = () => (
    <svg width="66" height="32" viewBox="0 0 66 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0655 14.2886V16.6862H13.7551V17.8464H10.6813C9.83602 17.8464 8.99074 17.537 8.37599 16.8409C7.76123 16.2222 7.45386 15.3714 7.45386 14.5206C7.45386 14.2113 7.5307 13.9019 7.5307 13.6699V13.5152C7.91492 12.2003 9.14442 11.1949 10.6045 11.1949C11.4497 11.1949 12.2182 11.5043 12.7561 12.0457L13.2172 12.5097C13.3708 12.6644 13.4477 12.8191 13.5245 13.0511C13.6014 13.2058 13.6014 13.2832 13.6782 13.4378C13.9856 10.6535 15.3688 8.10116 17.3667 6.39962C15.5225 4.85276 13.1403 3.92464 10.5276 3.92464C4.68748 3.92464 0 8.71991 0 14.5206C0 17.3823 1.07581 20.012 3.07376 22.0229C5.0717 24.0338 7.68439 25.1166 10.5276 25.1166C12.7561 25.1166 14.5235 24.4206 15.8298 23.0284L16.5214 22.3323V24.8846H21.7468V14.2886H11.0655Z" fill="#EBE0D1"/>
        <path d="M42.187 14.2885H53.022V24.8845H47.643V22.3322L46.9514 23.0283C45.645 24.4205 43.8776 25.1166 41.6491 25.1166C38.8059 25.1166 36.1932 24.0338 34.1953 22.0228C32.1973 20.0119 31.1215 17.3823 31.1215 14.5206C31.1215 8.71983 35.809 3.92456 41.6491 3.92456C44.2618 3.92456 46.644 4.85268 48.4883 6.39954C46.4903 8.10109 45.1071 10.6534 44.7997 13.4378C44.7229 13.2831 44.7229 13.2057 44.6461 13.051C44.5692 12.819 44.4924 12.6643 44.3387 12.5096L43.8776 12.0456C43.3397 11.5042 42.5713 11.1948 41.726 11.1948C40.266 11.1948 39.0365 12.2003 38.6522 13.5151V13.6698C38.6522 13.9018 38.5754 14.2112 38.5754 14.5206C38.5754 15.3713 38.8828 16.2221 39.4975 16.8409C40.1123 17.5369 40.9575 17.8463 41.8028 17.8463H44.8766V16.6862H42.187V14.2885Z" fill="#EBE0D1"/>
        <path d="M31.8137 0.0573104C29.5852 -0.174719 27.5872 0.28934 26.2809 1.60417C25.5893 2.22292 25.1282 2.99635 24.8977 3.92446C24.5903 4.85258 24.5135 5.93538 24.5903 7.09553C26.742 7.32756 28.6631 6.8635 29.9694 5.70335L30.1231 5.54867C31.4294 4.31118 31.9674 2.30026 31.8137 0.0573104Z" fill="#00E68F"/>
        <path d="M62.935 0.0573104C60.7066 -0.174719 58.7086 0.28934 57.4023 1.60417C56.7107 2.22292 56.2496 2.99635 56.0191 3.92446C55.7117 4.85258 55.6349 5.93538 55.7117 7.09553C57.8633 7.32756 59.7844 6.8635 61.0908 5.70335L61.2445 5.54867C62.5508 4.31118 63.0887 2.30026 62.935 0.0573104Z" fill="#00E68F"/>
        <path d="M61.0902 5.70345C59.7839 6.94094 57.8628 7.32766 55.7112 7.09563C55.6343 5.93548 55.7112 4.85268 56.0185 3.92456H55.2501C52.6374 3.92456 50.2552 4.85268 48.4878 6.39954C46.4899 8.10109 45.0299 10.5761 44.7993 13.4378C44.7993 13.7471 44.7225 14.0565 44.7225 14.2885H52.8679V24.8072C53.6364 24.9619 54.4048 25.1166 55.2501 25.1166C61.0902 25.1166 65.7777 20.3213 65.7777 14.5206C65.7777 10.8854 63.9335 7.63703 61.0902 5.70345ZM31.1211 14.5206C31.1211 12.355 31.7359 10.344 32.8885 8.71983C32.1201 7.55969 31.1211 6.55422 29.9685 5.70345C28.6621 6.94094 26.741 7.32766 24.5894 7.09563C24.5125 5.93548 24.5894 4.85268 24.8968 3.92456H24.1283C21.5156 3.92456 19.1335 4.85268 17.3661 6.39954C15.3681 8.10109 13.9081 10.5761 13.6776 13.4378C13.6776 13.7471 13.6007 14.0565 13.6007 14.2885H21.7462V24.8072C22.5146 24.9619 23.283 25.1166 24.1283 25.1166C27.8168 25.1166 31.0443 23.183 32.9654 20.3213C31.7359 18.6971 31.1211 16.6088 31.1211 14.5206Z" fill="#F546B3"/>
        <path d="M6.68419 30.0664C6.5305 30.6078 6.22312 31.0718 5.76206 31.4585C5.301 31.8453 4.68625 32 4.07149 32C3.30306 32 2.6883 31.7679 2.1504 31.2265C1.61249 30.6851 1.38196 30.0664 1.38196 29.2929C1.38196 28.5195 1.68933 27.9008 2.1504 27.3594C2.61146 26.818 2.99568 26.5859 3.68727 26.5859C4.30203 26.5859 5.22415 26.7406 5.76206 27.1273C6.22312 27.5141 6.60734 27.9781 6.76103 28.5195H5.53153C5.22415 27.9008 4.68625 27.5914 4.07149 27.5914C3.61043 27.5914 3.22621 27.7461 2.91884 28.0555C2.61146 28.3648 2.38093 28.8289 2.38093 29.2929C2.38093 29.757 2.53462 30.1437 2.84199 30.5304C3.14937 30.8398 3.53359 31.0718 3.99465 31.0718C4.30203 31.0718 4.6094 30.9945 4.83993 30.8398C5.07047 30.6851 5.301 30.4531 5.45469 30.1437L6.68419 30.0664ZM15.7518 26.6633H17.0581L18.9792 31.8453H17.7497L17.4423 30.9171H15.2907L14.9833 31.8453H13.8307L15.7518 26.6633ZM16.3665 27.9008L15.6749 29.989H17.135L16.3665 27.9008ZM26.8941 31.5359C26.5868 31.3039 26.3562 31.0718 26.2794 30.9171L27.0478 30.2984C27.1247 30.4531 27.3552 30.6078 27.5857 30.7625C27.8163 30.9171 28.1236 30.9945 28.431 30.9945C28.8152 30.9945 29.0458 30.9171 29.1226 30.7625C29.1994 30.6078 29.2763 30.5304 29.2763 30.4531C29.2763 29.989 28.2005 29.8343 27.432 29.4476C27.1247 29.3703 26.8941 29.1383 26.7404 28.9062C26.5099 28.6742 26.4331 28.3648 26.4331 28.0555C26.4331 27.7461 26.5099 27.4367 26.8173 27.1273C27.0478 26.818 27.2015 26.5859 27.8931 26.5859C28.5079 26.5859 29.3531 26.7406 29.6605 26.9727C29.9679 27.2047 30.0447 27.3594 30.1984 27.5141L29.5068 28.0555C29.2763 27.7461 28.8921 27.5141 28.2773 27.5141C28.1236 27.5141 27.8931 27.5914 27.8163 27.6687C27.6626 27.7461 27.5857 27.9008 27.5857 28.0555C27.5857 28.2101 27.6626 28.3648 27.8931 28.5195C28.0468 28.5969 28.3542 28.7515 28.5847 28.8289C28.8921 28.9062 29.1226 28.9836 29.43 29.1383C29.7374 29.2929 29.9679 29.4476 30.1216 29.6797C30.2753 29.9117 30.429 30.2211 30.429 30.5304C30.429 30.8398 30.2753 31.1492 30.0447 31.4585C29.7374 31.7679 29.1994 32 28.5079 32C27.7394 32 27.2015 31.8453 26.8941 31.5359ZM38.0365 31.8453V26.6633H39.1123V31.8453H38.0365ZM50.4852 29.989V26.6633H51.561V31.8453H50.5621L48.1031 28.5195V31.8453H47.0272V26.6633H48.0262L50.4852 29.989ZM62.1655 26.5859C62.9339 26.5859 63.5487 26.818 64.0866 27.3594C64.6245 27.9008 64.855 28.5195 64.855 29.2929C64.855 30.0664 64.6245 30.6851 64.0866 31.2265C63.5487 31.7679 62.8571 32 62.1655 32C61.4739 32 60.7823 31.7679 60.2444 31.2265C59.7065 30.6851 59.476 30.0664 59.476 29.2929C59.476 28.5195 59.7833 27.9008 60.2444 27.3594C60.7055 26.818 61.397 26.5859 62.1655 26.5859ZM62.1655 30.9945C62.6265 30.9945 63.0108 30.8398 63.3181 30.4531C63.6255 30.1437 63.7792 29.6797 63.7792 29.2156C63.7792 28.7515 63.6255 28.2875 63.3181 27.9781C63.0108 27.6687 62.6265 27.5141 62.1655 27.5141C61.7044 27.5141 61.3202 27.6687 60.936 27.9781C60.6286 28.2875 60.4749 28.7515 60.4749 29.2156C60.4749 29.6797 60.6286 30.0664 60.936 30.4531C61.3202 30.8398 61.7044 30.9945 62.1655 30.9945Z" fill="#EBE0D1"/>
    </svg>
);

const WoodLogo = () => (
    <svg width="69" height="32" viewBox="0 0 69 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.9131 31.4995H0.588379L5.98192 0.501343H29.3066L23.9131 31.4995Z" fill="#0B0B0B"/>
        <path d="M8.76143 10.9368L8.26654 11.236L7.78344 11.1126C7.76192 10.8233 8.63079 10.5251 8.76194 10.9368H8.76143ZM18.218 22.2533C18.1643 22.246 18.092 22.2797 18.0582 22.3227C17.9419 22.4716 17.8318 22.6271 17.7273 22.7843C17.6878 22.8434 17.6192 22.8755 17.549 22.8662C16.8809 22.7796 16.2277 23.058 15.5853 23.21C15.4762 23.2312 15.3107 23.2608 15.2682 23.1182C15.2431 22.9995 15.2544 22.8791 15.2641 22.7588C15.2723 22.6572 15.198 22.5675 15.0976 22.5582C14.9834 22.5478 14.8701 22.5701 14.8148 22.6956C14.6094 23.1203 14.5663 23.6077 14.5822 24.0734C14.5894 24.3617 14.9301 24.4483 15.1555 24.4167C16.0843 24.2777 17.0034 24.0511 17.9276 23.8805C17.9926 23.8685 18.0459 23.8214 18.0654 23.7576C18.1858 23.3614 18.2765 22.9533 18.4071 22.5602C18.4855 22.4145 18.3528 22.2714 18.218 22.2527V22.2533ZM15.6683 20.1282C15.8451 20.2371 16.1002 20.1007 16.1335 19.9073C16.2129 19.5557 16.259 19.199 16.3512 18.8495C16.3538 18.8396 16.3594 18.8308 16.3676 18.824C16.3676 18.824 18.2765 18.0042 18.6468 18.2593C18.6699 18.2754 18.695 18.2873 18.6899 18.3138C18.6335 18.6006 18.5761 18.8904 18.5193 19.1777C18.5131 19.2099 18.5259 19.242 18.5521 19.2612C18.6422 19.3255 18.8487 19.4479 18.9122 19.2674C19.0946 18.7473 19.3405 18.2547 19.5352 17.7434C19.5429 17.7232 19.5347 17.6998 19.5152 17.6879C19.0137 17.3897 18.384 17.495 17.84 17.6459C17.1299 17.8689 16.4378 18.1924 15.8369 18.626C15.8138 18.6426 15.7969 18.6669 15.7887 18.6939C15.6944 19.0087 15.6094 19.3286 15.5592 19.6506C15.5592 19.6543 15.5582 19.6579 15.5582 19.6615C15.5464 19.8207 15.5233 20.0214 15.6688 20.1287L15.6683 20.1282ZM5.56772 0L0 32H24.3293L29.8976 0H5.56772ZM15.4685 1.00133C16.5864 2.03948 17.0454 3.71492 14.8988 6.35955C13.6365 6.03079 12.2886 5.53972 9.70048 5.80263C10.1795 3.37423 9.22096 1.89739 7.94738 1.00133H15.4685ZM8.74503 11.2936C8.57136 11.3678 8.40691 11.4901 8.21019 11.4901C7.27011 11.4756 5.99652 10.2855 5.99652 10.2855C6.25677 10.214 6.47604 10.2819 6.66559 10.424C6.8244 10.5552 7.00627 10.6682 7.1697 10.5738C7.72708 10.2518 8.26142 9.8795 8.84596 9.60882C9.42179 9.35991 10.1503 9.35213 10.6318 9.79861C11.0412 10.2129 11.5161 10.5422 12.0187 10.8212C12.4218 11.0447 12.8476 11.2443 13.304 11.3247C13.304 11.3247 13.1053 11.8345 13.4044 12.2789C13.3312 12.2794 13.2456 12.2726 13.2041 12.2C13.0074 11.9143 12.9808 11.8433 12.824 11.6986C12.4454 11.3175 11.9172 11.1541 11.4049 11.054C10.5253 10.8855 9.58265 10.913 8.74503 11.2936ZM10.5463 14.7866C9.92077 15.0858 9.28961 15.3881 8.72915 15.8092C8.16459 16.224 7.71837 16.8095 7.45403 17.4774C7.09131 18.3833 6.9868 19.3608 6.93301 20.3279C6.92994 20.3839 6.85463 20.3979 6.83209 20.3465C6.20093 18.9153 5.88791 17.3384 5.83053 15.7604C5.80902 15.0065 5.84283 14.24 6.01343 13.5016C6.02265 13.4612 6.07183 13.4472 6.10154 13.4757C6.57542 13.932 7.16355 14.238 7.77831 14.4277C8.66153 14.7041 9.59904 14.7617 10.5191 14.686C10.5781 14.6808 10.5991 14.7612 10.5463 14.7866ZM6.39817 1.00133H6.87563C7.9028 1.67441 8.72095 2.62544 9.06727 3.80515C9.67333 6.23977 7.92073 6.98026 5.19015 7.9427L6.39817 1.00133ZM1.17881 30.9987L3.83767 15.7179C4.41196 18.8972 5.89611 20.5327 6.78957 23.0342C7.28548 24.4229 7.24296 26.0014 7.03138 27.0151C6.76446 28.2908 6.03084 29.4669 4.51186 30.9987H1.17881ZM11.5299 30.9987H5.72961C6.30595 30.4029 6.83363 29.7012 7.1615 28.9146C7.83774 27.2915 7.63948 26.0838 7.85055 24.0532C8.08006 21.813 8.94534 20.5399 9.78757 18.8775C10.1795 18.1079 10.6308 17.3633 11.1769 16.7011C11.4982 16.3168 11.8522 15.957 12.2635 15.6816L12.5504 15.5131C12.5504 15.5131 12.8255 15.3637 12.8885 15.5846C12.9731 15.8802 12.6186 16.0399 12.3988 16.1934C11.6421 16.6586 10.9766 17.2985 10.4966 18.0747C9.98635 18.8915 9.7015 19.8523 9.67128 20.8231C9.62466 22.3103 10.1298 23.756 10.8644 24.9954C10.9771 25.2619 12.6811 28.2534 11.5299 30.9987ZM16.6791 30.9987H12.2733C12.5863 30.3733 12.8342 29.7127 12.9982 29.0276C13.2159 28.1331 13.3302 27.1541 13.0089 26.2798C13.9844 26.5495 15.0361 26.6532 16.0218 26.3374C16.6407 26.1564 17.0336 26.0615 17.717 25.4175C18.6079 24.3804 17.6724 24.3814 17.6724 24.3814C17.2498 24.3669 16.8389 24.5126 16.424 24.5831C15.8871 24.6915 15.3404 24.7796 14.7943 24.7885C14.2953 24.7926 13.7774 24.747 13.3291 24.4965C12.7784 24.1812 12.3127 23.7239 11.9054 23.2219C9.65079 20.1728 12.0525 17.3923 12.0525 17.3923C12.2589 17.1393 12.5284 16.9396 12.8209 16.8136C12.8962 16.7768 13.0028 16.7493 13.055 16.811C13.0914 16.8774 12.9055 17.0288 12.8035 17.1113C12.6841 17.2134 12.6795 17.3892 12.8112 17.4462C12.9521 17.5002 13.1119 17.5023 13.2533 17.5562C13.5515 17.6723 13.8307 17.8445 14.092 18.041C14.0925 18.041 14.0935 18.0421 14.0945 18.0426C14.3507 18.2153 14.4777 18.4237 14.7815 18.4621C15.0535 18.4989 15.529 18.319 15.7318 18.1116C15.9444 17.8964 16.2144 17.7709 16.4798 17.6449C17.0141 17.397 17.5674 17.1994 18.1115 16.9723C18.3553 16.8649 18.6069 16.7638 18.8241 16.601C18.9394 16.7369 19.1607 17.1564 19.3743 17.2238C19.6684 17.2928 19.8595 17.1958 20.1612 17.2482C20.5542 17.6272 20.778 18.1551 20.9527 18.6783C21.2427 19.6211 21.3293 20.6281 21.2944 21.6217C21.2191 23.7695 20.5552 25.8821 19.4968 27.7261C19.4968 27.7261 18.4634 29.4192 16.6791 30.9987ZM22.9984 24.8445C21.8728 26.8528 19.5383 29.3211 18.7898 29.9522C25.1413 21.8628 20.6136 16.1063 20.6136 16.1063C20.8574 15.2979 20.5731 14.3914 20.2842 14.1737C20.2709 14.1638 20.2529 14.1638 20.2391 14.1721C19.6812 14.5092 19.4968 15.3062 19.2068 15.3928C19.2022 15.3938 19.1971 15.3943 19.1925 15.3948C19.0172 15.3985 18.8963 15.2408 18.7872 15.1185C18.5572 14.8156 18.2355 14.6165 17.9291 14.4101C17.4844 14.128 17.0244 13.8719 16.5356 13.693C16.4183 13.6463 16.2815 13.6095 16.2067 13.4964C16.2026 13.4897 16.2001 13.4814 16.1996 13.4736C16.1909 13.2942 16.4275 13.302 16.5484 13.288H16.5536C17.3584 13.2921 18.0592 13.8133 18.86 13.8402C19.1766 13.8439 19.5024 13.7967 19.7842 13.6287C19.942 13.5332 20.0793 13.3704 20.0787 13.1713C20.0649 12.8187 19.8892 12.4583 19.5772 12.3094C19.3513 12.1871 19.0721 12.2877 18.8518 12.1617C18.7304 12.0937 18.7027 11.9376 18.7186 11.8049C18.7391 11.5995 18.798 11.3683 18.6796 11.1847C18.5244 10.9156 18.2073 10.8679 17.9455 10.7823C17.3794 10.5785 16.8517 10.2752 16.3517 9.92876C16.1704 9.82505 15.9193 9.58963 15.8604 9.37391C15.7979 9.12345 15.8374 8.90825 15.924 8.65831C16.0541 8.45555 16.344 8.57119 16.4219 8.76617C16.4219 8.76617 16.7657 9.7955 17.2636 10.1569C17.8466 10.5785 17.8082 9.57407 17.8082 9.57407C17.7805 7.85662 15.4993 6.66291 15.4993 6.66291C15.8932 5.63513 16.9378 4.8853 18.009 4.68358C19.0803 4.48135 20.1428 4.60269 21.3339 5.00457C20.2457 5.16273 19.1387 5.51638 18.3784 6.31962C19.2252 6.0702 20.2283 6.25429 21.0347 6.61624C21.818 6.96782 22.6792 7.73787 23.2929 8.7169C24.5235 10.6812 24.607 13.1028 24.5512 15.4037C24.1628 14.5045 23.2299 13.3357 22.2909 13.0935C25.6126 15.8081 24.9461 21.3691 22.9984 24.8445Z" fill="#B19661"/>
        <path d="M40.3469 10.9472C40.3469 13.066 39.1338 15.2843 35.2987 15.2843H29.3503L31.7961 1.2227H37.2941C39.0944 1.2227 41.0155 1.79726 41.0155 4.47092C41.0155 6.72871 39.7009 7.81767 38.1548 8.03599C39.5047 8.25378 40.3464 9.16488 40.3464 10.9477L40.3469 10.9472ZM36.5708 10.6106C36.5708 9.69951 36.2383 9.26392 35.1814 9.26392H34.0856L33.479 12.7891H34.5943C36.1599 12.7891 36.5708 11.6405 36.5708 10.6106ZM37.2946 4.94644C37.2946 3.99593 36.8249 3.7185 36.101 3.7185H35.0641L34.4964 6.96673H35.5528C36.9227 6.96673 37.2946 5.7782 37.2946 4.94644Z" fill="white"/>
        <path d="M46.3121 4.23277L45.9023 6.55745H50.344L49.8317 9.56455H45.4018L44.8997 12.273H49.7717L49.2563 15.2837H40.686L43.1317 1.22205H51.5648L51.0468 4.23226H46.3116L46.3121 4.23277Z" fill="white"/>
        <path d="M62.2563 4.23291H59.0278L57.0907 15.2843H53.4124L55.3494 4.23291H52.1014L52.6296 1.2227H62.7845L62.2563 4.23291Z" fill="white"/>
        <path d="M34.0159 25.647H34.0743L37.2429 16.8958H42.2702L39.825 30.9533H36.578L38.4166 20.6777H38.3577L34.5436 30.9533H31.8248L31.4729 20.6974H31.4139L29.7121 30.9533H26.6213L29.0666 16.8958H33.8786L34.0159 25.647Z" fill="#B19661"/>
        <path d="M60.7471 25.647H60.8055L63.9741 16.8958H69.0013L66.5561 30.9533H63.3091L65.1478 20.6777H65.0889L61.2748 30.9533H58.556L58.204 20.6974H58.1451L56.4432 30.9533H53.3525L55.7977 16.8958H60.6098L60.7471 25.647Z" fill="#B19661"/>
        <path d="M41.9911 25.9237C41.9911 22.9933 42.8907 16.5586 48.7002 16.5586C52.7638 16.5586 54.2797 18.3559 53.811 21.3972L50.4216 21.4527C50.6019 20.3368 50.1106 19.3168 48.7392 19.2712C46.2171 19.1866 45.235 23.6986 45.235 25.8174C45.235 28.0944 46.3068 28.6715 47.2448 28.6378C48.4538 28.5942 49.2484 27.9367 49.6193 26.5568L49.7955 25.6463H47.6244L48.0742 22.9731H53.688L52.2992 30.9521H49.5645L49.9328 28.9126C49.3068 30.4175 48.231 31.2887 46.4118 31.2887C44.4558 31.2887 41.9911 30.6555 41.9911 25.9237Z" fill="#B19661"/>
    </svg>
);

const ExpektLogo = () => (
    <svg width="103" height="29" viewBox="0 0 103 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M84.7888 17.2695C84.5112 16.8823 84.5667 16.661 84.8443 16.2738C86.7876 13.8949 88.6754 11.5161 90.6186 9.13731C90.7297 9.02667 90.7297 8.86071 90.7852 8.75006C90.6741 8.69474 90.5076 8.63942 90.3965 8.63942C88.953 8.63942 87.4539 8.63942 86.0103 8.63942C85.344 8.63942 84.8999 8.86071 84.5112 9.3586C83.1787 11.0182 81.8462 12.6779 80.5692 14.2822C80.2916 14.6141 80.0139 14.946 79.7363 15.278C79.6808 15.278 79.6808 15.2226 79.6253 15.2226C79.6253 15.0567 79.6253 14.8907 79.6808 14.7248C80.0695 11.9034 80.4581 9.02667 80.8468 6.20529C80.9578 5.59675 80.8468 5.48611 80.236 5.48611C79.0145 5.48611 77.7931 5.48611 76.5716 5.48611C76.0164 5.48611 75.8498 5.59675 75.7388 6.20529C74.8504 12.2353 73.9621 18.21 73.0182 24.24C72.9071 24.8485 73.0182 24.9039 73.6289 24.9039H77.5155C77.9596 24.9039 78.1817 24.6826 78.2372 24.24C78.4038 23.1336 78.5704 21.9718 78.7369 20.8654L79.2922 17.2142C79.4587 17.4355 79.5698 17.5461 79.6808 17.7121C81.1799 19.925 82.679 22.0825 84.1226 24.2953C84.4557 24.7379 84.7888 24.9592 85.344 24.9592H89.5082C89.6748 24.9592 89.8413 24.9039 90.0634 24.9039C89.9524 24.7379 89.9524 24.6273 89.8413 24.5166C88.1201 22.0825 86.4545 19.7037 84.7888 17.2695ZM35.1523 17.2695C35.0412 17.0483 34.9857 16.8823 35.1523 16.661C37.0955 14.3375 39.0943 12.0693 41.0376 9.74585C41.3152 9.46924 41.5373 9.13731 41.8149 8.75006C41.6483 8.69474 41.5373 8.69474 41.4262 8.69474C39.7606 8.69474 38.0949 8.69474 36.4293 8.69474C36.1517 8.69474 35.8185 8.91603 35.652 9.13731C35.3188 9.46924 35.0968 9.85649 34.8191 10.1884C34.0974 11.1289 33.3756 12.014 32.5983 13.0098C32.4872 12.7885 32.3762 12.6226 32.3207 12.4566C31.7654 11.3502 31.2102 10.1884 30.655 9.08199C30.4884 8.75006 30.2663 8.5841 29.8777 8.5841C28.6007 8.5841 27.3237 8.5841 26.0467 8.5841C25.7691 8.5841 25.4915 8.63942 25.2139 8.69474C25.3249 8.97135 25.4359 9.24796 25.547 9.46924C26.824 11.6268 28.101 13.7843 29.378 15.9418C29.489 16.1631 29.6001 16.3291 29.378 16.5504C27.3237 18.8739 25.3249 21.1973 23.2706 23.5208C22.9375 23.9081 22.6043 24.2953 22.2157 24.7932C22.3822 24.8485 22.4378 24.8485 22.5488 24.8485H27.5458C27.8789 24.8485 28.212 24.6826 28.4341 24.406C29.2669 23.4655 29.9887 22.5251 30.766 21.5293C31.0992 21.0867 31.4878 20.6995 31.8765 20.2016C31.9875 20.3675 32.043 20.4228 32.0986 20.5335C32.7648 21.7506 33.3756 22.9676 34.0418 24.1847C34.2639 24.6273 34.597 24.8485 35.0967 24.8485H39.0388C39.2054 24.8485 39.3719 24.7932 39.594 24.7379C39.483 24.5166 39.4275 24.2953 39.3164 24.1847C37.9284 21.9718 36.5403 19.593 35.1523 17.2695ZM102.445 8.63942C102.112 8.63942 101.779 8.63942 101.501 8.63942H99.8908C100.057 7.75428 100.224 6.92446 100.39 6.09464C100.446 5.7074 100.335 5.54143 100.002 5.54143C98.6138 5.54143 97.1702 5.54143 95.7822 5.54143C95.3935 5.54143 95.2825 5.7074 95.1714 6.03932C95.0604 6.7585 94.8938 7.533 94.7272 8.25217C94.6717 8.52878 94.5607 8.63942 94.2831 8.63942C93.7278 8.63942 93.1726 8.5841 92.6729 8.63942C92.3953 8.63942 92.0622 8.80539 91.9512 8.97135C91.1183 9.96713 90.3965 11.0182 89.6192 12.0693C89.5082 12.18 89.4527 12.3459 89.3416 12.5672H94.0055C93.9499 12.7885 93.9499 12.8992 93.9499 13.0651C93.6168 14.7801 93.2837 16.4397 93.0616 18.1547C92.895 19.0951 92.784 20.0909 92.8395 21.0314C93.0061 22.9676 94.061 24.24 95.8377 24.8485C97.7809 25.5124 99.6132 25.0698 101.39 24.1847C101.834 23.9634 102.056 23.6315 102.056 23.1336C102.112 22.1931 102.167 21.2527 102.223 20.3122C102.223 19.925 102.278 19.5377 102.278 19.0398C102.001 19.2058 101.834 19.3164 101.667 19.4271C100.946 19.8696 100.224 20.2569 99.3911 20.3122C98.5583 20.3675 98.0586 19.9803 98.0586 19.1505C98.0586 18.5972 98.1141 18.044 98.2251 17.4908C98.5583 15.8312 98.8914 14.1715 99.2245 12.5119H101.667C102.056 12.5119 102.334 12.3459 102.445 11.9587C102.667 11.0182 102.833 10.1331 103 9.19263C103 8.86071 102.833 8.63942 102.445 8.63942ZM53.9187 9.3586C52.253 8.30749 50.4208 8.19685 48.5886 8.47346C48.3665 8.52878 48.0889 8.52878 47.8113 8.5841C47.8668 8.30749 47.9223 8.08621 47.9778 7.86492C48.0889 7.25639 47.9778 7.03511 47.3116 7.03511C46.2011 7.03511 45.0352 7.03511 43.9247 7.03511C43.425 7.03511 43.2029 7.25639 43.0364 7.69896C42.9253 8.08621 42.8698 8.41814 42.8143 8.80539C41.6483 15.0567 40.8155 21.3633 39.9272 27.6146C39.8161 28.2231 39.9827 28.4444 40.6489 28.4444H44.0913C44.7576 28.4444 44.9796 28.2231 45.0907 27.504C45.2017 26.5635 45.3683 25.623 45.4793 24.6273C45.6459 24.6826 45.757 24.7379 45.868 24.7379C46.7563 24.9039 47.7002 25.1252 48.5886 25.1252C51.4757 25.1252 53.8631 23.9081 55.4733 21.4186C56.9168 19.2611 57.3055 16.827 56.9168 14.2822C56.6392 12.2353 55.6954 10.5203 53.9187 9.3586ZM51.2536 18.21C50.4763 20.4228 48.533 21.2527 46.5343 20.9207C46.1456 20.8654 46.0901 20.5335 46.1456 20.2016C46.2566 19.4271 46.3677 18.5972 46.4787 17.8227C46.7008 16.3291 46.9784 14.8907 47.145 13.397C47.3116 12.18 47.5892 12.2353 48.533 12.18C50.3653 12.18 51.4202 13.1758 51.6423 15.0014C51.7533 16.1078 51.6423 17.2142 51.2536 18.21ZM22.7709 20.1462C22.4933 20.2569 22.3267 20.3122 22.1601 20.3675C20.9387 20.8101 19.7172 21.3633 18.4402 21.474C17.4408 21.5846 16.4414 21.6399 15.4975 21.308C14.3316 20.9207 13.6653 19.4824 13.8319 18.5972H22.8264C23.4927 18.5972 23.7148 18.4313 23.7703 17.7674C23.8258 16.7716 23.9368 15.7759 23.8813 14.7801C23.7148 12.4566 22.8264 10.5203 20.8276 9.30328C18.1071 7.64364 14.1095 8.14153 11.6665 10.4097C10.334 11.6268 9.39012 13.1204 8.89042 14.8907C8.77938 15.2226 8.66833 15.3886 8.27968 15.3333C7.83551 15.278 7.39133 15.278 6.94715 15.3333C6.66955 15.3886 6.33641 15.5546 6.16985 15.7205C5.55911 16.4397 5.05941 17.1589 4.50419 17.9334C4.39315 18.0994 4.2821 18.3206 4.11554 18.5419C4.39315 18.5972 4.55971 18.5972 4.7818 18.5972H8.05759C8.50177 18.5972 8.61281 18.7079 8.66833 19.1505C9.05699 21.6399 10.334 23.5208 12.6659 24.4613C15.6641 25.6784 18.7178 25.4571 21.6605 24.1294C21.8825 24.0187 22.0491 23.7421 22.1046 23.5208C22.2712 22.7463 22.4378 21.9718 22.6043 21.1973C22.6043 20.9207 22.6598 20.5888 22.7709 20.1462ZM15.7196 12.5119C16.7745 11.5161 18.4402 11.9587 18.7733 13.397C18.9399 14.0056 18.8844 14.6141 18.9954 15.278H14.1095C14.5537 14.2822 14.8868 13.2864 15.7196 12.5119ZM73.0182 14.1715C72.7406 12.2906 71.9633 10.7416 70.4642 9.6352C67.6881 7.533 62.7466 7.86492 59.8595 11.4608C58.0828 13.729 57.4721 16.2738 57.8607 19.1505C58.3049 21.9718 59.8595 23.8528 62.469 24.7379C65.3006 25.623 68.1323 25.4018 70.8528 24.1847C71.0194 24.074 71.2415 23.8528 71.2415 23.6315C71.4636 22.6357 71.6301 21.5846 71.8522 20.5888C71.8522 20.4782 71.8522 20.3675 71.8522 20.2016C71.6857 20.2569 71.5191 20.3122 71.408 20.3675C70.6863 20.6441 69.909 20.9761 69.1872 21.1973C67.7991 21.6399 66.4111 21.8612 64.9675 21.5293C63.6905 21.2527 62.8022 20.0356 62.9132 18.7079H72.0743C72.6295 18.7079 72.7961 18.5419 72.9071 17.9887C73.1292 16.661 73.1848 15.4439 73.0182 14.1715ZM68.1323 15.0014C68.1323 15.112 67.9657 15.3333 67.9102 15.3333C66.4111 15.3333 64.912 15.3333 63.3574 15.3333C63.746 14.3375 64.1347 13.397 64.801 12.6779C65.4117 12.014 66.1335 11.9034 66.9108 12.1247C67.6881 12.3459 67.9657 13.0651 68.0767 13.8396C68.1323 14.1715 68.1323 14.6141 68.1323 15.0014Z" fill="white"/>
        <path d="M3.95486 1.74936C3.95486 1.79681 3.94229 1.85403 3.93112 1.92381L3.2594 5.75956H4.8933L5.58875 1.79611C5.63483 1.50653 5.6474 1.34464 5.6474 1.14717C5.6474 0.428443 5.3695 0 4.61539 0C3.96533 0 3.26918 0.219804 2.38939 0.637082L2.40056 0.0111646L0.962181 0.254693L0 5.75956H1.63459L2.27279 2.12058C2.71338 1.88892 3.43257 1.58747 3.73351 1.58747C3.8962 1.58747 3.95486 1.63422 3.95486 1.74936Z" fill="white"/>
        <path d="M13.8741 3.95158C13.909 3.54617 13.9209 3.16378 13.9209 2.79255C13.9209 1.80728 13.828 0.938527 13.6772 0.069779L12.1124 0.31261C12.3331 1.87775 12.472 3.37172 12.4832 5.75956H14.3161L15.7077 3.19867L16.1944 5.75956H18.0845L19.2429 2.32852C19.4866 1.70261 19.5683 1.28603 19.5683 0.903638C19.5683 0.613357 19.5215 0.335637 19.4517 0.0104668L17.8751 0.31261C17.9449 0.567303 17.9679 0.752915 17.9679 0.927362C17.9679 1.10181 17.9449 1.27416 17.8981 1.50653L17.2836 3.8818L16.5994 0.092806L15.0926 0.324472L15.2902 1.21625L13.8741 3.95158Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.75132 2.13175C6.98384 0.834557 7.56338 0 9.34879 0C10.4157 0 11.2271 0.463332 11.2271 1.41372C11.2271 2.51483 10.6594 3.02422 9.2671 3.4415C8.6451 3.63217 8.5798 3.64917 8.20534 3.74665C8.16868 3.7562 8.12906 3.76651 8.08567 3.77783L8.01584 4.17139C7.98093 4.38072 8.00397 4.56634 8.30562 4.56634C8.89773 4.56634 9.75517 4.27605 10.5204 3.94042L10.8333 5.09875C10.149 5.52789 9.07089 5.87609 8.0738 5.87609C6.90215 5.87609 6.4036 5.366 6.4036 4.40375C6.4036 4.19441 6.42734 3.96414 6.47342 3.71992L6.75132 2.13175ZM9.23428 1.263C9.53453 1.263 9.70909 1.39069 9.70909 1.58747C9.70909 1.92381 9.50031 2.13245 9.05902 2.26014C8.80312 2.33866 8.66873 2.3712 8.49624 2.41296C8.44187 2.42612 8.38372 2.44019 8.31679 2.45692L8.38661 2.06267C8.46761 1.59933 8.64147 1.263 9.23428 1.263Z" fill="white"/>
    </svg>
);

const LeoVegasLogo = () => (
    <svg width="134" height="33" viewBox="0 0 134 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.3057 32.6531C7.32523 32.6531 0 25.3185 0 16.2913C0 7.26407 7.32523 0 16.3057 0C25.2861 0 32.6114 7.3346 32.6114 16.3265C32.6114 25.3185 25.3214 32.6531 16.3057 32.6531ZM44.0923 17.5255V12.8708H46.2757V5.74779H34.7949V12.8355H36.6966V19.888H34.7949V26.9758H51.4175V25.7416C52.791 26.6584 54.4814 27.1521 56.3832 27.1521C58.4258 27.1521 60.2219 26.6937 61.701 25.8474L62.6871 25.2479C64.131 26.4821 66.0328 27.1874 68.1458 27.1874C71.3506 27.1874 74.0271 25.5653 75.3654 23.0264L77.0558 26.9758H81.775L83.3597 23.2027C84.7332 25.6358 87.4098 27.1168 90.685 27.1168C92.3754 27.1168 93.8545 26.8347 95.1576 26.2353C95.1224 26.4469 95.1224 26.6584 95.1224 26.87C95.1224 27.9984 95.5802 29.0563 96.3902 29.9026C97.658 31.172 99.9119 31.9478 102.342 31.9478C104.878 31.9478 106.92 31.0662 108.258 29.3736C108.963 28.4921 109.421 27.4695 109.632 26.3058C110.583 26.87 111.71 27.1874 112.978 27.1874C113.506 27.1874 114.069 27.1168 114.633 27.0111H123.155V26.6232C124.177 26.9758 125.304 27.1521 126.395 27.1521C130.41 27.1521 133.333 24.6837 133.333 21.2985C133.333 20.1349 133.016 19.1475 132.347 18.3365C132.805 17.7018 133.052 16.926 133.052 16.0797C133.052 14.9513 132.594 13.8934 131.784 13.0471C130.445 11.7071 128.156 11.1077 126.466 11.1077C123.613 11.1077 121.606 12.3066 120.549 13.9287C120.444 13.7524 120.338 13.6113 120.197 13.4703C119.317 12.3771 117.626 11.1077 114.492 11.1077C113.224 11.1077 112.203 11.3193 111.393 11.6366V11.284H103.398C102.87 11.1429 102.307 11.1077 101.778 11.1077C99.595 11.1077 97.6228 12.0598 96.2141 13.6818C94.8406 12.0245 92.7276 11.1077 90.2624 11.1077H90.0158V5.74779H68.8149V11.1077C68.6036 11.1077 68.4275 11.0724 68.2162 11.0724C65.751 11.0724 63.4971 12.095 62.018 13.7876C60.6445 12.0598 58.4962 11.0724 55.9606 11.0724C52.0866 11.0724 48.9523 13.7524 48.2479 17.4549H44.1979L44.0923 17.5255Z" fill="url(#paint0_linear_194_8829)"/>
        <path opacity="0.27" d="M16.3028 1.27014C8.02665 1.27014 1.26489 8.04054 1.26489 16.3272C1.26489 24.6139 8.02665 31.4196 16.338 31.4196C24.6493 31.4196 31.411 24.6492 31.411 16.3272C31.411 8.00528 24.6141 1.27014 16.3028 1.27014Z" fill="#030303"/>
        <path d="M16.658 21.6512C16.4819 21.5101 16.2354 21.5454 16.0593 21.6865C15.4254 22.2507 14.5097 22.8149 13.5941 23.0264C13.418 23.0617 13.3476 23.3085 13.4532 23.5201C13.6293 23.908 14.0519 24.4369 14.4393 24.7896C14.8267 25.1422 15.1436 25.248 15.4254 25.4595C15.7071 25.6711 16.1297 26.2353 16.3058 26.4822C16.341 26.5527 16.4467 26.5527 16.4819 26.4822C16.6228 26.2353 16.9397 25.7064 17.2919 25.4243C17.6793 25.1069 18.7006 24.5427 18.9471 23.8727C19.0528 23.5906 19.2289 23.2027 19.3697 22.9559C19.5458 22.6033 19.4402 22.3917 19.1937 22.3917C18.2428 22.3564 17.2919 22.0743 16.658 21.6512Z" fill="#F7F7F7"/>
        <path d="M16.3052 2.25745C8.55734 2.25745 2.25342 8.56943 2.25342 16.3272C2.25342 24.1202 8.55734 30.3969 16.3052 30.3969C24.053 30.3969 30.3571 24.0849 30.3571 16.3272C30.3922 8.56943 24.0882 2.25745 16.3052 2.25745ZM25.673 7.58208L23.9474 9.30994V9.20416C23.9474 8.56943 23.56 8.18154 23.0669 7.75839L23.0317 7.72313L24.4756 6.48895C24.8982 6.80631 25.2856 7.19419 25.673 7.58208ZM9.64909 5.39581L10.5647 4.86687C10.6352 4.83161 10.7408 4.76108 10.8113 4.72582L12.6426 7.12367L12.3256 4.16162C12.8187 3.98531 13.3469 3.84426 13.9104 3.73847L15.143 7.29998L15.4952 3.5269C15.7769 3.5269 16.0234 3.49163 16.3052 3.49163C16.5869 3.49163 16.8334 3.49163 17.1152 3.5269L17.4674 7.15893L18.7 3.73847C19.2282 3.84426 19.7565 3.98531 20.2848 4.12636L19.9678 7.22946L21.7639 4.72582C22.2569 4.97266 22.7148 5.2195 23.1726 5.5016L22.2922 7.19419C21.7991 6.94736 21.2708 6.84157 21.0595 7.19419C20.7074 7.75839 20.3552 8.14628 20.2495 8.14628C19.8622 8.11102 19.1578 7.75839 18.383 7.75839C16.8687 7.75839 16.4108 8.81627 16.4108 8.81627C16.4108 8.81627 15.6361 7.75839 14.2626 7.75839C12.8891 7.75839 12.4665 8.18154 12.4665 8.18154C12.4665 8.18154 12.1143 7.33524 11.8678 7.08841C11.6917 6.91209 11.0226 7.01788 10.3887 7.37051L10.3534 7.26472L9.43778 5.53686C9.473 5.5016 9.57865 5.46633 9.64909 5.39581ZM19.7565 10.5794C18.7352 10.791 18.1365 11.2846 17.9252 11.4257C17.6787 11.5667 17.573 11.1436 17.6787 10.932C17.7843 10.7204 18.0308 10.7204 18.2774 10.4736C18.8761 9.90941 19.1578 9.83888 19.7565 9.80362C20.1791 9.76836 20.5665 9.83888 20.813 9.90941C21.0595 9.97993 21.2356 10.262 21.4117 10.6147C21.4822 10.791 21.6582 11.2846 21.623 11.7078C21.623 11.8488 21.5174 11.8841 21.4822 11.8136C21.4469 11.7431 21.13 10.2973 19.7565 10.5794ZM21.3061 12.413C21.1652 12.5188 20.8835 12.413 20.8835 12.413C20.8835 12.413 20.4608 13.0125 20.2848 13.1183C20.1439 13.2241 18.5239 13.612 18.5239 13.612C18.5239 13.612 18.3478 13.9293 18.1717 13.8588C17.9252 13.7883 18.1717 12.4483 18.3126 12.0957C18.4182 11.7431 19.3339 11.5667 19.8974 11.5315C20.4608 11.5315 21.0243 11.9194 21.3413 12.1662C21.4117 12.2015 21.4117 12.3073 21.3061 12.413ZM14.4034 11.9194C13.9808 11.8488 13.7695 11.3904 13.3117 10.8968C12.6074 10.1915 11.8326 10.7557 11.3747 10.8968C11.0578 10.9673 10.8817 10.4383 11.2691 9.97993C11.6917 9.48626 12.8891 9.48626 13.3469 9.76836C13.5582 9.90941 14.1569 10.932 14.65 11.1083C15.6713 11.4962 15.143 12.0252 14.4034 11.9194ZM14.5443 13.9646C14.3682 14.0351 14.333 13.8235 14.2274 13.753C14.1921 13.7178 13.9808 13.7883 13.84 13.6825C13.6639 13.5767 13.6287 13.3651 13.4174 13.2241C12.8539 12.8715 12.5017 12.9772 12.3608 12.9067C12.22 12.8362 12.0087 12.6246 12.0087 12.6246C12.0087 12.6246 11.7269 12.7304 11.6213 12.6246C11.5156 12.5188 11.5156 12.4483 11.586 12.3778C11.903 12.1309 12.4313 11.7431 12.9595 11.7783C13.4878 11.7783 14.333 11.9899 14.4387 12.3073C14.5091 12.5188 14.6147 13.1183 14.6147 13.5414C14.6147 13.753 14.7204 13.8941 14.5443 13.9646ZM8.09952 6.52421L9.50822 7.82892L9.61387 7.93471C9.19126 8.35786 8.80387 8.85153 8.69821 9.23942L6.93734 7.61734L8.09952 6.52421ZM29.0187 17.9493C28.9483 18.4782 28.8426 19.0071 28.737 19.5361L22.433 18.3371L28.2439 21.0524C28.0326 21.546 27.8213 22.0397 27.5748 22.4981L21.7991 19.7829L26.7296 23.8381C26.4126 24.2612 26.0604 24.6844 25.7083 25.0723L21.13 21.4755L24.5109 26.2007C24.0882 26.5533 23.6656 26.8707 23.2078 27.1528L19.8974 22.7802L21.8343 27.9285C21.3413 28.1754 20.8482 28.3517 20.32 28.528L18.5591 25.037L18.8056 28.9159C18.2774 29.0217 17.7139 29.0922 17.1504 29.1275L16.3756 26.9412L15.6008 29.1275C15.0374 29.0922 14.5091 29.0217 13.9456 28.9159L14.0513 25.2486L12.4313 28.528C11.903 28.3517 11.41 28.1754 10.9169 27.9285L12.5721 23.2386L9.54343 27.188C9.08561 26.9059 8.663 26.5886 8.24039 26.2359L12.0087 21.0171L7.07821 25.1428C6.69082 24.7549 6.37386 24.3318 6.0569 23.9086L10.9873 19.7829L5.17647 22.5334C4.92995 22.075 4.68342 21.5813 4.47212 21.0876L10.3182 18.3371L3.97907 19.5713C3.8382 19.0424 3.73255 18.5135 3.66212 17.9845L10.0013 16.7503L3.52125 16.3977V16.3272V15.763L3.55646 15.4809C3.55646 15.2693 3.59168 15.0225 3.6269 14.8109L9.71952 15.1283L3.90864 13.2241C4.04951 12.6951 4.19038 12.2015 4.40168 11.6725L9.19126 12.7657L5.07082 10.1915L5.91603 8.81627L10.1773 10.7557C10.1069 10.9673 9.96604 11.3904 10.0013 12.1662C10.0365 13.2946 9.89561 14.0351 10.3534 14.4935C10.8465 14.9872 11.4804 15.3751 11.8326 15.8335C11.903 15.9393 11.9734 16.0098 12.0087 16.1156C12.1143 16.2214 12.1495 16.2919 12.1847 16.3624L12.2904 16.574C12.5369 16.1509 13.0652 15.904 13.1708 15.9746C13.2413 16.0451 12.8539 16.3977 12.4665 17.3498C12.396 17.5614 12.2552 17.914 12.1495 18.1961C12.0087 18.6192 11.9382 19.0424 12.0087 19.6066C12.1143 20.5234 12.7482 21.6871 12.9947 22.0044C13.1708 22.216 13.7343 22.1102 14.1569 22.0044C14.5795 21.8987 15.3191 21.4755 15.6008 21.1229C15.9178 20.7703 16.1291 20.5234 16.0234 19.9592C15.953 19.5713 15.5656 19.0424 15.2487 18.8308C14.9317 18.6545 14.4034 18.2666 14.2626 18.055C14.1921 17.9493 14.0865 17.7729 13.9808 17.6319C13.9104 17.4908 13.84 17.3851 13.8752 17.3145C13.9808 17.244 14.0161 17.2793 14.1217 17.3851C14.2274 17.4908 14.2978 17.6319 14.333 17.5966C14.3682 17.5614 14.333 17.5614 14.333 17.4556C14.3682 17.3851 14.4387 17.2793 14.6147 17.1735C14.9669 16.9972 15.6361 17.4203 16.3404 17.4203C17.0448 17.4203 17.9604 16.7856 18.2421 17.0324C18.4182 17.1735 18.4535 17.3145 18.4535 17.4203C18.4535 17.4203 18.4535 17.4556 18.4887 17.4556C18.5943 17.4556 18.7 17.3145 18.8056 17.2087C18.8761 17.1382 18.9465 17.103 19.0169 17.1382C19.0874 17.1735 19.0521 17.3145 19.0169 17.4556C18.9817 17.5966 18.9113 17.7377 18.8408 17.7729C18.6295 17.9493 18.2069 17.9493 17.573 18.5135C16.9743 19.0424 16.6574 19.5361 16.6221 19.8887C16.5869 20.1355 16.7278 20.6645 16.9743 20.9466C17.2208 21.2287 17.5378 21.4402 18.1365 21.546C18.6648 21.6166 19.6861 21.405 19.9678 21.1581C20.3552 20.8055 20.5665 20.4176 20.7074 19.8182C20.8482 19.1834 20.7426 18.2314 20.6369 17.8787C20.32 16.8914 19.8269 16.3272 19.9678 16.2214C20.0735 16.1156 20.3904 16.433 20.6017 16.6093C20.6369 16.4682 20.6722 16.0803 20.7426 15.8688C20.8482 15.4104 21.0595 15.1635 21.5174 14.9167C22.0456 14.5993 22.8556 14.1409 22.9261 13.612C22.9965 13.083 23.0669 12.0604 22.9613 11.7078C22.8909 11.4962 22.8204 11.1436 22.75 10.8968L26.6591 8.78101C26.9761 9.20416 27.2578 9.66257 27.5396 10.1562L23.56 12.6599L28.2439 11.602C28.4552 12.0957 28.6313 12.6246 28.737 13.1536L22.6091 15.1283L29.0187 14.7051C29.0891 15.234 29.1243 15.763 29.1243 16.2919V16.3272L22.7148 16.7856L29.0187 17.9493Z" fill="#F7F7F7"/>
        <path opacity="0.27" d="M130.52 18.3372C131.33 17.9493 131.823 17.103 131.823 16.1157C131.823 15.3046 131.506 14.5994 130.907 13.9647C129.815 12.8715 127.843 12.3778 126.47 12.3778C123.723 12.3778 120.94 13.9294 120.94 16.9267C120.94 18.2314 121.433 19.113 122.208 19.7477C121.363 20.0298 120.729 20.7703 120.588 21.6871H120.306V17.6672C120.306 16.292 119.919 15.0578 119.215 14.282C118.51 13.4005 117.137 12.3778 114.46 12.3778C112.383 12.3778 110.939 13.0126 110.093 13.8941V12.5894H103.895V12.8363C103.261 12.5894 102.557 12.4131 101.712 12.4131C99.2112 12.4131 97.1334 13.9294 96.1473 16.1509C95.2316 13.8589 93.0834 12.4131 90.2307 12.4131C88.5755 12.4131 87.1316 12.9773 86.0047 13.8941L86.9555 11.6373H88.7164V7.05321H80.1233V11.6373H81.532L79.419 17.0678L77.3059 11.6373H78.609V7.05321H70.0159V11.6373H71.8825L72.9742 14.2115C71.7416 13.0831 70.0864 12.4131 68.1494 12.4131C65.2616 12.4131 62.902 13.9647 61.8455 16.3272C61.0002 13.9294 58.7815 12.4131 55.8585 12.4131C52.1959 12.4131 49.4489 15.1283 49.2376 18.7956H45.3285V21.1582H42.7576V11.6021H44.9411V7.01794H35.9958V11.6021H37.8976V21.1582H35.9958V25.7423H50.1181V22.604C51.2802 24.6139 53.5341 25.8834 56.3163 25.8834C58.1476 25.8834 59.7324 25.4955 61.0003 24.755L61.7046 24.3318L61.4229 23.556C61.3524 23.3797 60.8594 21.934 60.6481 21.4756L60.472 21.0524H61.4229C62.1976 23.9439 64.7685 25.9186 68.079 25.9186C72.0233 25.9186 74.9816 22.9918 74.9816 19.1482V19.113L77.799 25.7423H80.8629L83.5394 19.4656C83.6803 23.274 86.5681 25.8834 90.6181 25.8834C92.4494 25.8834 94.0342 25.4955 95.3021 24.755L96.0064 24.3318L95.7247 23.556C95.6542 23.3797 95.1612 21.934 94.9499 21.4756L94.7738 21.0524H95.6895C96.1121 22.4982 96.9573 23.6618 98.0842 24.4376C97.0277 24.7197 96.2529 25.7071 96.2529 26.8707C96.2529 27.6818 96.5699 28.387 97.1686 29.0217C98.1899 30.0443 100.162 30.7143 102.205 30.7143C104.353 30.7143 106.043 29.9738 107.135 28.5986C107.98 27.5054 108.403 26.2007 108.403 24.6492V22.8155C108.826 24.6844 110.551 25.9539 112.876 25.9539C113.791 25.9539 114.707 25.7423 115.587 25.3192V25.7423H121.786V24.6492C122.842 25.3897 124.638 25.8834 126.258 25.8834C129.604 25.8834 131.928 24.0145 131.928 21.2992C132.104 19.8535 131.435 18.9719 130.52 18.3372ZM55.8585 16.6093C56.4572 16.6093 56.915 16.7857 57.1968 17.1383H54.5907C55.0133 16.7151 55.5063 16.6093 55.8585 16.6093ZM56.7742 21.5461C55.8585 21.5461 55.2598 21.3345 54.8724 21.0524H59.1689C58.3237 21.3698 57.5137 21.5461 56.7742 21.5461ZM90.1955 16.6093C90.7942 16.6093 91.2521 16.7857 91.5338 17.1383H88.9277C89.3503 16.7151 89.8786 16.6093 90.1955 16.6093ZM91.1112 21.5461C90.1955 21.5461 89.5968 21.3345 89.2094 21.0524H93.506C92.6608 21.3698 91.886 21.5461 91.1112 21.5461ZM100.338 18.9719C100.338 17.5262 101.007 16.7857 102.31 16.7857C102.839 16.7857 103.332 16.9267 103.789 17.1735V20.594C103.296 20.9819 102.803 21.1582 102.31 21.1582C101.043 21.1229 100.338 20.3472 100.338 18.9719ZM103.508 25.8834C103.156 26.3418 102.522 26.4476 102.064 26.4476C101.817 26.4476 101.606 26.4123 101.43 26.377C101.395 25.9892 101.254 25.6365 101.043 25.3544C101.254 25.3897 101.43 25.3897 101.641 25.3897C102.522 25.3897 103.226 25.2134 103.825 24.9313C103.754 25.3897 103.684 25.7423 103.508 25.8834ZM108.579 20.8408V16.6799H109.178C109.283 17.4556 109.741 18.0551 110.34 18.4077C109.424 18.9719 108.826 19.8182 108.579 20.8408ZM115.658 21.3698C115.059 21.7224 114.46 21.8987 113.897 21.8987C113.228 21.8987 113.228 21.6519 113.228 21.5108C113.228 20.9819 113.932 20.8761 114.39 20.8761C114.813 20.8761 115.27 20.9114 115.693 20.9466V21.3698H115.658ZM113.897 17.4909H113.791C113.967 17.2088 114.073 16.8914 114.108 16.5388C115.024 16.5388 115.376 16.7857 115.552 16.9972C115.623 17.0678 115.693 17.2793 115.728 17.5967C115.129 17.5262 114.496 17.4909 113.897 17.4909ZM126.434 16.433C126.61 16.433 126.786 16.433 126.963 16.4683C126.998 16.6799 127.033 16.8562 127.068 17.0325C126.399 16.8562 125.941 16.6799 125.66 16.5741C125.836 16.5036 126.082 16.433 126.434 16.433ZM126.505 21.8635C126.188 21.8635 125.836 21.8282 125.519 21.7577C125.483 21.5108 125.448 21.2992 125.378 21.0877C125.589 21.1582 125.836 21.2287 126.047 21.264C126.751 21.4756 127.139 21.6166 127.35 21.6871C127.174 21.7929 126.892 21.8635 126.505 21.8635Z" fill="#030303"/>
        <path d="M87.4798 18.1607C87.7615 16.3623 88.9941 15.6218 90.1915 15.6218C91.8115 15.6218 92.7976 16.6092 92.868 18.1607H87.4798ZM90.2619 13.365C86.8458 13.365 84.6271 15.9744 84.6271 19.1481C84.6271 22.5685 87.1628 24.8606 90.7198 24.8606C92.3398 24.8606 93.7837 24.5432 94.9106 23.8732C94.9106 23.8732 94.3824 22.3217 94.1711 21.8633C93.1498 22.2864 92.1285 22.5333 91.0719 22.5333C89.2054 22.5333 87.8319 21.7575 87.4445 20.0649H95.4389C95.5446 19.677 95.5798 19.1128 95.5798 18.6897C95.6502 15.7629 93.7837 13.365 90.2619 13.365ZM68.1806 13.365C64.5532 13.365 62.264 16.0802 62.264 19.1481C62.264 22.2512 64.518 24.9311 68.1806 24.9311C71.808 24.9311 74.0971 22.2159 74.0971 19.1481C74.0971 16.045 71.8784 13.365 68.1806 13.365ZM67.1241 16.3623C67.2297 15.9039 67.5819 15.375 67.9693 15.0576C68.0749 14.9871 68.2158 15.0576 68.2158 15.1634C68.2158 15.6571 68.6384 16.0802 68.6032 16.6797C68.568 17.1381 68.3215 17.5965 67.8636 17.5965C67.1945 17.526 66.9832 16.9265 67.1241 16.3623ZM65.011 15.8334C65.0462 15.6923 65.2575 15.6923 65.2927 15.8334C65.5745 16.3976 66.2084 16.5034 66.3845 16.9618C66.5254 17.3497 66.5606 17.8786 65.9971 18.196C65.4336 18.5133 65.0462 17.9491 64.9054 17.4202C64.7997 16.9618 64.8701 16.3271 65.011 15.8334ZM69.378 23.1327C68.7793 23.0622 68.0397 22.4275 67.3354 22.4275C66.8071 22.4275 65.9267 22.6743 65.4336 22.5685C64.9406 22.4627 64.7645 21.6517 64.7645 20.9817C64.7645 20.2765 65.5041 19.6417 66.138 19.0775C66.6662 18.6191 67.6171 18.0549 68.0397 18.0549C68.6032 18.0549 69.2019 18.5133 69.5188 19.8886C69.7654 21.017 70.5402 20.9465 70.5402 21.5107C70.5402 22.4275 69.9767 23.2385 69.378 23.1327ZM69.8358 18.1255C69.378 17.9844 69.2371 17.526 69.378 17.0676C69.5188 16.6092 70.0119 16.3271 70.2584 15.7981C70.3288 15.6571 70.5049 15.6571 70.5402 15.7981C70.7162 16.2213 70.9275 16.7855 70.8923 17.2086C70.8571 17.7376 70.5049 18.337 69.8358 18.1255ZM72.0193 20.1002C71.7728 20.6291 71.2093 20.6996 70.8571 20.5233C70.3641 20.2412 70.3288 19.6065 70.7162 19.1481C70.998 18.7954 71.6319 18.7249 71.8432 18.2312C71.9136 18.0902 72.0897 18.0902 72.1249 18.2312C72.3715 18.8307 72.2306 19.677 72.0193 20.1002ZM46.4162 22.1454H41.8379V10.6146H44.0214V8.00513H37.0483V10.6146H38.9853V22.1454H37.0483V24.7195H49.1631V19.7828H46.4162V22.1454ZM55.9249 13.365C52.5088 13.365 50.2901 15.9744 50.2901 19.1481C50.2901 22.5685 52.8258 24.8606 56.3827 24.8606C58.0027 24.8606 59.4466 24.5432 60.5736 23.8732C60.5736 23.8732 60.0453 22.3217 59.834 21.8633C58.8127 22.2864 57.7914 22.5333 56.7349 22.5333C54.8684 22.5333 53.4949 21.7575 53.1075 20.0649H61.1019C61.2075 19.677 61.2427 19.1128 61.2427 18.6897C61.3132 15.7629 59.4466 13.365 55.9249 13.365ZM53.1427 18.1607C53.4245 16.3623 54.6571 15.6218 55.8545 15.6218C57.4745 15.6218 58.4606 16.6092 58.531 18.1607H53.1427ZM104.948 14.564H104.912C104.208 13.9292 103.152 13.365 101.778 13.365C98.855 13.365 96.5659 15.8334 96.5659 19.007C96.5659 22.2864 98.8198 24.4374 101.637 24.4374C103.116 24.4374 103.962 23.8732 104.842 22.9917V24.6138C104.842 25.4601 104.666 26.0948 104.314 26.5179C103.821 27.1879 103.011 27.47 102.06 27.47C101.391 27.47 100.862 27.329 100.405 27.1879C100.44 27.0821 100.44 26.9058 100.44 26.7648C100.44 25.9185 99.7706 25.319 98.9254 25.319C98.0098 25.319 97.4463 26.0948 97.4463 26.8353C97.4463 27.3642 97.6224 27.8226 98.0802 28.2811C98.855 29.0568 100.51 29.6563 102.412 29.6563C104.208 29.6563 105.652 29.0921 106.568 27.9284C107.237 27.0821 107.624 25.9537 107.624 24.5785V15.6571H109.209V13.5413H104.948V14.564ZM104.772 21.017C104.067 21.687 103.257 22.1101 102.306 22.1101C100.581 22.1101 99.348 21.017 99.348 18.9718C99.348 16.856 100.581 15.7629 102.306 15.7629C103.292 15.7629 104.102 16.0802 104.772 16.6092V21.017ZM126.923 17.9844C125.198 17.4907 124.599 17.2086 124.599 16.5386C124.599 15.9744 125.233 15.4103 126.465 15.4103C127.029 15.4103 127.557 15.516 128.05 15.6923C128.015 15.8334 128.015 15.9744 128.015 16.186C128.015 17.0323 128.649 17.5613 129.494 17.5613C130.304 17.5613 130.868 16.9265 130.868 16.0802C130.868 15.5513 130.692 15.0929 130.234 14.6345C129.459 13.8587 127.839 13.3298 126.501 13.3298C123.402 13.3298 121.958 15.1281 121.958 16.856C121.958 18.7602 123.261 19.4654 126.289 20.2765C128.015 20.7701 128.473 21.0522 128.473 21.6164C128.473 22.4275 127.557 22.8154 126.465 22.8154C125.691 22.8154 124.986 22.6743 124.458 22.498C124.493 22.357 124.493 22.2159 124.493 22.0043C124.493 21.0522 123.789 20.5233 123.014 20.5233C122.169 20.5233 121.535 21.1933 121.535 22.0043C121.535 22.5685 121.711 23.0622 122.169 23.4854C122.873 24.1906 124.74 24.8253 126.43 24.8253C128.966 24.8253 131.114 23.5911 131.114 21.2286C131.114 19.3949 129.6 18.7249 126.923 17.9844ZM119.352 17.667C119.352 16.5739 119.07 15.5513 118.506 14.8813C117.732 13.9292 116.393 13.365 114.562 13.365C111.569 13.365 110.16 14.8461 110.16 16.2213C110.16 17.1381 110.794 17.7023 111.639 17.7023C112.484 17.7023 113.118 17.0676 113.118 16.2565C113.118 16.1155 113.083 15.8687 113.012 15.6923C113.259 15.5866 113.646 15.516 114.104 15.516C115.09 15.516 115.83 15.7629 116.288 16.3271C116.569 16.6444 116.71 17.1734 116.71 17.8434V18.7602C116.076 18.6191 115.055 18.4781 113.893 18.4781C111.287 18.4781 109.455 19.7828 109.455 21.828C109.455 23.9438 111.181 24.9311 113.048 24.9311C114.527 24.9311 115.865 24.2611 116.781 23.4854V24.7195H120.972V22.6391H119.352V17.667ZM116.675 21.9338C115.83 22.5685 114.879 22.9212 113.893 22.9212C112.907 22.9212 112.238 22.4275 112.238 21.5459C112.238 20.5586 113.048 19.9238 114.386 19.9238C115.231 19.9238 116.041 20.0296 116.675 20.1707V21.9338ZM81.1758 10.6146H83.0071L79.4502 19.7828L75.858 10.6146H77.6189V8.00513H71.0684V10.6146H72.5828L78.5697 24.7195H80.3306L86.3176 10.6146H87.7615V8.00513H81.1758V10.6146Z" fill="#F7F7F7"/>
        <defs>
            <linearGradient id="paint0_linear_194_8829" x1="44.6537" y1="16.396" x2="82.8118" y2="12.4228" gradientUnits="userSpaceOnUse">
                <stop stopColor="#500800"/>
                <stop offset="1" stopColor="#962E15"/>
            </linearGradient>
        </defs>
    </svg>
);

interface SurvivorCouponProps {
    couponShareId?: number;
    publicCouponId?: string;
}

const SurvivorCoupon: React.FC<SurvivorCouponProps> = (props) => {
    const { t } = useTranslation();

    const isPublic = !!props.publicCouponId;
    const [privateCouponShare] = useCouponShare(props.couponShareId ?? 0);
    const [publicCouponShare] = usePublicCouponShare(props.publicCouponId ?? "");
    const couponShare = isPublic ? publicCouponShare : privateCouponShare;
    const [showShareDialog, setShowShareDialog] = useState(false);
    const [publicUrl, setPublicUrl] = useState<string | undefined>(undefined);
    const [isSharing, setIsSharing] = useState(false);
    const cashout = useCashout(couponShare);
    const chartCardRef = useRef<HTMLDivElement>(null);
    const captureRef = useRef<HTMLDivElement>(null);
    const captureWrapperRef = useRef<HTMLDivElement>(null);
    const roundId = couponShare?.coupon?.roundId;

    useEffect(() => {
        setPublicUrl(couponShare?.publicUrl);
    }, [couponShare]);

    const publishCoupon = async (cs: CouponShare): Promise<string | undefined> => {
        const headers = new Headers({ Accept: 'application/json' });
        const token = getCurrentToken();
        if (token) headers.set('Authorization', 'Bearer ' + token);
        const res = await fetch(new URL(cs._links.publish.href), { headers, method: 'POST' });
        if (res.ok) {
            const data = await res.json();
            const url = (data as CouponShare).publicUrl;
            setPublicUrl(url);
            return url;
        }
        return undefined;
    };

    const themeFlags = getSurvivorThemeFlags((window as any).theme);
    const { isGoGo, isGreen, isKryss, isLyllo, isDbet, isOrange, isOrangeLight, isWood, isLion, isHajper, isStugan, isSnabbare, isHard } = themeFlags;

    const shareEnabled = IsShareCouponEnabled((window as any).theme);

    // Theme-aware colors
    const tc = getSurvivorThemeColors(themeFlags);

    const captureChartImage = async (): Promise<File | null> => {
        const target = (isGoGo || isLion || isWood || isOrange) ? captureWrapperRef.current : captureRef.current;
        if (!target) return null;
        try {
            const dataUrl = await toPng(target, {
                skipFonts: true,
                pixelRatio: 2,
                cacheBust: true,
                backgroundColor: (isGoGo || isWood || isOrange) ? undefined : tc.cardInnerBg,
            });
            const res = await fetch(dataUrl);
            const blob = await res.blob();
            return new File([blob], 'coupon-trend.png', { type: 'image/png' });
        } catch (e) {
            console.error('[Share] capture failed:', e);
            return null;
        }
    };

    const handleShare = async () => {
        if (!couponShare || isSharing) return;
        setIsSharing(true);
        try {
            let url = publicUrl;
            if (!url) {
                url = await publishCoupon(couponShare);
            }
            if (!url) { setIsSharing(false); return; }

            const imageFile = await captureChartImage();

            const shareData: ShareData = {
                title: getRoundName(round!, t),
                text: t('check_out_my_coupon'),
                url: url,
            };

            const canShareFiles = imageFile && navigator.canShare?.({ files: [imageFile] });            

            if (canShareFiles) {
                shareData.files = [imageFile];
            }
            if (navigator.share) {
                await navigator.share(shareData);
                track("coupon_shared", { method: "native_share", round_id: round?.id });
            } else {
                setShowShareDialog(true);
            }
        } catch (err: any) {
            if (err?.name !== 'AbortError') {
                setShowShareDialog(true);
            }
        } finally {
            setIsSharing(false);
        }
    };
    const detailRoundResponse = useDetailRound(roundId);
    const round = detailRoundResponse?.round as DetailedRound | undefined;

    const correctSigns = (round?.fixtures ?? []).map((fixture, idx) => {
        if (fixture.status !== "FINISHED") return undefined;
        const sign = round?.preliminaryCorrectRow?.[idx];
        return sign === "ONE" ? "1" : sign === "TWO" ? "2" : "X";
    });

    const anyGameStarted = (round?.fixtures ?? []).some(f => f.status === "PLAYING" || f.status === "FINISHED");
    const outcomeTreeResponse = useOutcomeTree(anyGameStarted ? roundId : undefined, correctSigns, Number(round?.operatorStakePerRow?.amount) || 1);
    const numberOfCouponsLeftPerOutcome = outcomeTreeResponse.outcomeTree;
    const totalRowsPerGame = outcomeTreeResponse.totalRowsPerGame;

    useInterval(() => {
        detailRoundResponse?.reloadDetailRound?.();
        outcomeTreeResponse?.reloadOutcomeTree?.();
    }, 20000);

    if (!couponShare?.coupon) return null;
    if (detailRoundResponse.status === "loading") return <div></div>;

    const deepCoupon = couponShare.coupon.coupon;

    if (round === undefined) {
        return <></>;
    }

    const numRows = Math.round(round.operatorTurnover.amount / round.operatorStakePerRow.amount);

    // For syndicate shares the deep coupon holds the full syndicate rows; scale them down to this share.
    const shareFraction = Number(couponShare.totalStakePercentage) > 0 ? Number(couponShare.totalStakePercentage) : 1;
    const isPartialShare = shareFraction < 1;

    const locale = t('locale') || 'sv-SE';
    const formatCount = (n: number) => new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n);
    const formatUserCount = (n: number) =>
        new Intl.NumberFormat(locale, { maximumFractionDigits: isPartialShare ? 1 : 0 }).format(n);

    const calculateUserRowsPerOutcome = () => {
        const userRows = (deepCoupon?.bets ?? []).flatMap(bet => bet.rows ?? []);
        const result: { [gameNumber: number]: { "1": number; "X": number; "2": number } } = {};

        round.fixtures.forEach((_, gameIdx) => {
            const gameNumber = gameIdx + 1;
            result[gameNumber] = { "1": 0, "X": 0, "2": 0 };
        });

        userRows.forEach((row) => {
            let rowSurvives = true;
            for (let gameIdx = 0; gameIdx < round.fixtures.length; gameIdx++) {
                const gameNumber = gameIdx + 1;
                const fixture = round.fixtures[gameIdx];
                const correctSign = round.preliminaryCorrectRow?.[gameIdx];
                const gameSign = row.signs?.[gameIdx];

                if (rowSurvives && gameSign) {
                    const signKey = gameSign === "ONE" ? "1" : gameSign === "TWO" ? "2" : "X";
                    result[gameNumber][signKey]++;

                    if (fixture.status === "FINISHED" && correctSign) {
                        const correctSignStr = correctSign === "ONE" ? "ONE" : correctSign === "TWO" ? "TWO" : "X";
                        if (gameSign !== correctSignStr) {
                            rowSurvives = false;
                        }
                    }
                }
            }
        });

        if (isPartialShare) {
            Object.values(result).forEach((counts) => {
                counts["1"] *= shareFraction;
                counts["X"] *= shareFraction;
                counts["2"] *= shareFraction;
            });
        }

        return result;
    };

    const userRowsPerOutcome = calculateUserRowsPerOutcome();
    const gameNumbers = round.fixtures.map((_, idx) => idx + 1);

    const calculateCouponValuePerGame = () => {
        const result: { [gameNumber: number]: number } = {};
        const turnoverAmount = round.operatorTurnover.amount;

        gameNumbers.forEach((gameNumber) => {
            const userGameData = userRowsPerOutcome[gameNumber];
            const totalGameData = numberOfCouponsLeftPerOutcome?.[gameNumber];
            if (!userGameData || !totalGameData) return;

            const fixture = round.fixtures[gameNumber - 1];
            if (!fixture) return;

            const isFinished = fixture.status === "FINISHED";
            const isPlaying = fixture.status === "PLAYING";
            const correctSignRaw = round.preliminaryCorrectRow?.[gameNumber - 1];
            const correctKey =
                correctSignRaw === "ONE" ? "1" : correctSignRaw === "TWO" ? "2" : correctSignRaw === "X" ? "X" : undefined;

            let userRows: number;
            let totalRows: number;

            if (isFinished && correctKey) {
                userRows = userGameData[correctKey as keyof typeof userGameData] ?? 0;
                totalRows = totalGameData[correctKey as keyof typeof totalGameData] ?? 0;
            } else if (isPlaying) {
                const homeScore = fixture.homeTeam.score ?? 0;
                const awayScore = fixture.awayTeam.score ?? 0;
                const currentKey = homeScore > awayScore ? "1" : awayScore > homeScore ? "2" : "X";
                userRows = userGameData[currentKey as keyof typeof userGameData] ?? 0;
                totalRows = totalGameData[currentKey as keyof typeof totalGameData] ?? 0;
            } else {
                userRows = Object.values(userGameData).reduce((sum, count) => sum + count, 0);
                totalRows = Object.values(totalGameData).reduce((sum, count) => sum + count, 0);
            }

            if (totalRows > 0) {
                result[gameNumber] = (userRows / totalRows) * turnoverAmount * 0.8;
            }
        });

        return result;
    };

    const couponValuePerGame = calculateCouponValuePerGame();

    const firstUnfinishedGame = gameNumbers.find((gameNum) => {
        const fixture = round.fixtures[gameNum - 1];
        return fixture && fixture.status !== "FINISHED";
    });

    const totalOutcomeDataForFirst = firstUnfinishedGame
        ? numberOfCouponsLeftPerOutcome?.[firstUnfinishedGame]
        : undefined;
    const totalRowsRemainingForFirst = totalOutcomeDataForFirst
        ? Object.values(totalOutcomeDataForFirst).reduce((sum, count) => sum + count, 0)
        : 0;

    const userOutcomeDataForFirst = firstUnfinishedGame ? userRowsPerOutcome[firstUnfinishedGame] : undefined;
    const userRowsRemainingForFirst = userOutcomeDataForFirst
        ? Object.values(userOutcomeDataForFirst).reduce((sum, count) => sum + count, 0)
        : 0;

    const showProjections = !!firstUnfinishedGame && totalRowsRemainingForFirst > 0 && userRowsRemainingForFirst > 0;

    const calculateProjectedValuesForNextGame = () => {
        if (!firstUnfinishedGame) return { projections: {}, lastActualValue: 0 };
        const gameData = numberOfCouponsLeftPerOutcome?.[firstUnfinishedGame];
        const userGameData = userRowsPerOutcome[firstUnfinishedGame];
        const turnoverAmount = round.operatorTurnover.amount;

        if (!gameData || !userGameData) return { projections: {}, lastActualValue: 0 };

        const projections: { [outcome: string]: number } = {};
        const outcomes: Array<"1" | "X" | "2"> = ["1", "X", "2"];
        outcomes.forEach((outcome) => {
            const totalRowsForOutcome = gameData[outcome] ?? 0;
            const userRowsForOutcome = userGameData[outcome] ?? 0;

            if (totalRowsForOutcome > 0) {
                const valuePerRow = (turnoverAmount * 0.8) / totalRowsForOutcome;
                projections[outcome] = userRowsForOutcome * valuePerRow;
            } else {
                projections[outcome] = 0;
            }
        });

        const lastActualValue = couponValuePerGame[firstUnfinishedGame] || 0;

        return { projections, lastActualValue };
    };

    const projectedData = calculateProjectedValuesForNextGame();
    const projectedValues = projectedData.projections;

    const calculateRowsLeftPerGame = () => {
        const result: { [gameNumber: number]: { count: number; percent: number } } = {};

        gameNumbers.forEach((gameNumber) => {
            const totalGameData = numberOfCouponsLeftPerOutcome?.[gameNumber];
            if (!totalGameData) return;

            const fixture = round.fixtures[gameNumber - 1];
            if (!fixture) return;

            const isFinished = fixture.status === "FINISHED";
            const isPlaying = fixture.status === "PLAYING";
            const correctSignRaw = round.preliminaryCorrectRow?.[gameNumber - 1];
            const correctKey =
                correctSignRaw === "ONE" ? "1" : correctSignRaw === "TWO" ? "2" : correctSignRaw === "X" ? "X" : undefined;

            let rowsLeft: number;
            if (isFinished && correctKey) {
                rowsLeft = totalGameData[correctKey as keyof typeof totalGameData] ?? 0;
            } else if (isPlaying) {
                const homeScore = fixture.homeTeam.score ?? 0;
                const awayScore = fixture.awayTeam.score ?? 0;
                const currentKey = homeScore > awayScore ? "1" : awayScore > homeScore ? "2" : "X";
                rowsLeft = totalGameData[currentKey as keyof typeof totalGameData] ?? 0;
            } else {
                rowsLeft = Object.values(totalGameData).reduce((sum, count) => sum + count, 0);
            }

            const percent = numRows > 0 ? (rowsLeft / numRows) * 100 : 0;
            result[gameNumber] = { count: rowsLeft, percent };
        });

        return result;
    };

    const rowsLeftPerGame = calculateRowsLeftPerGame();

    const calculateUserRowsLeftPerGame = () => {
        const result: { [gameNumber: number]: { count: number; percent: number } } = {};
        const userStartRows = userRowsPerOutcome[1]
            ? Object.values(userRowsPerOutcome[1]).reduce((sum, count) => sum + count, 0)
            : 0;

        gameNumbers.forEach((gameNumber) => {
            const userData = userRowsPerOutcome[gameNumber];
            if (!userData) return;

            const fixture = round.fixtures[gameNumber - 1];
            if (!fixture) return;

            const isFinished = fixture.status === "FINISHED";
            const isPlaying = fixture.status === "PLAYING";
            const correctSignRaw = round.preliminaryCorrectRow?.[gameNumber - 1];
            const correctKey =
                correctSignRaw === "ONE" ? "1" : correctSignRaw === "TWO" ? "2" : correctSignRaw === "X" ? "X" : undefined;

            let rowsLeft: number;
            if (isFinished && correctKey) {
                rowsLeft = userData[correctKey as keyof typeof userData] ?? 0;
            } else if (isPlaying) {
                const homeScore = fixture.homeTeam.score ?? 0;
                const awayScore = fixture.awayTeam.score ?? 0;
                const currentKey = homeScore > awayScore ? "1" : awayScore > homeScore ? "2" : "X";
                rowsLeft = userData[currentKey as keyof typeof userData] ?? 0;
            } else {
                rowsLeft = Object.values(userData).reduce((sum, count) => sum + count, 0);
            }

            const percent = userStartRows > 0 ? (rowsLeft / userStartRows) * 100 : 0;
            result[gameNumber] = { count: rowsLeft, percent };
        });

        return result;
    };

    const userRowsLeftPerGame = calculateUserRowsLeftPerGame();

    const isAfterDeadline = new Date(round.openTo) < new Date();

    const SurvivorFixture: React.FC<{ fixture: Fixture; index: number }> = ({ fixture, index }) => {
        const signs = deepCoupon?.bets?.[0]?.legs?.[index]?.signs ?? [];
        const isFinished = fixture.status === "FINISHED";
        const isPlaying = fixture.status === "PLAYING";
        const correctSign = round.preliminaryCorrectRow?.[index];
        const gameNumber = index + 1;

        const homeScore = fixture.homeTeam.score ?? 0;
        const awayScore = fixture.awayTeam.score ?? 0;
        const currentSign = homeScore > awayScore ? "ONE" : awayScore > homeScore ? "TWO" : "X";

        const userOutcomeData = userRowsPerOutcome[gameNumber];
        const totalOutcomeData = numberOfCouponsLeftPerOutcome?.[gameNumber];

        const isNextGame = gameNumber === firstUnfinishedGame;

        const fixtureDate = new Date(fixture.startingAt);
        const today = new Date();
        const isSameDay = fixtureDate.getFullYear() === today.getFullYear()
            && fixtureDate.getMonth() === today.getMonth()
            && fixtureDate.getDate() === today.getDate();
        const isUpcoming = !isFinished && !isPlaying;

        const getStatusText = () => {
            if (isFinished) return t('full_time');
            if (isPlaying) return 'LIVE';
            if (isUpcoming && !isSameDay) {
                const weekday = fixtureDate.toLocaleDateString(locale, { weekday: 'long' }).replace(/^./, c => c.toUpperCase());
                const time = fixtureDate.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
                return `${weekday} ${time}`;
            }
            return fixtureTime(fixture, t);
        };
        const statusText = getStatusText();

        const renderSignBox = (label: string) => {
            const selected = signs.includes(label as any);
            const isCorrect = isFinished && correctSign === label;
            const isWrong = isFinished && selected && !isCorrect;
            const isLiveCurrent = isPlaying && currentSign === label;
            const displaySign = label === "ONE" ? "1" : label === "TWO" ? "2" : "X";

            let bg = tc.signBg;
            let border = tc.signBorder;
            let color: string = tc.signColor;

            if (selected && !isFinished && !isPlaying) {
                bg = tc.signSelected;
                border = '0.5px solid #B3B3B3';
                color = tc.signSelectedText;
            }
            if (isPlaying && selected) {
                bg = tc.signSelected;
                color = tc.signSelectedText;
            }
            if (isCorrect && selected) {
                bg = tc.signSelected;
                border = tc.signCorrectBorder;
                color = tc.signSelectedText;
            } else if (isCorrect && !selected) {
                border = tc.signCorrectBorder;
            } else if (isWrong) {
                bg = tc.signSelected;
                border = '0.5px solid #B3B3B3';
                color = tc.signWrongText;
            }
            if (isLiveCurrent) {
                border = tc.liveBorder;
                if (selected) {
                    bg = tc.signSelected;
                    color = tc.signSelectedText;
                }
            }

            // Lion: finished games use same selected color as active
            if (isLion && isFinished) {
                if (selected) {
                    bg = '#31609A';
                    color = '#FFFFFF';
                    border = '0.5px solid #636363';
                } else {
                    bg = '#CBCBCB';
                    color = '#A8A8A8';
                    border = 'none';
                }
                if (isCorrect) {
                    border = tc.signCorrectBorder;
                }
            }

            const showDoubleBorder = selected && (isCorrect || isLiveCurrent);

            return (
                <Grid
                    sx={{
                        position: 'relative',
                        width: 48,
                        minWidth: 48,
                        maxWidth: 48,
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                        border,
                        backgroundColor: bg,
                        color,
                        fontWeight: 700,
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontFamily: tc.fontFamily,
                        boxSizing: 'border-box',
                    }}
                >
                    {displaySign}
                    {showDoubleBorder && (
                        <Grid sx={{
                            position: 'absolute',
                            inset: 0,
                            border: `2px solid ${tc.doubleBorderColor}`,
                            borderRadius: '4px',
                            pointerEvents: 'none',
                        }} />
                    )}
                </Grid>
            );
        };

        const renderRowCount = (label: string, data: { "1": number; "X": number; "2": number } | undefined, labelColor: string, valueColor: string, fmt: (n: number) => string = formatCount) => {
            if (!data) return null;
            return (
                <Grid container alignItems="center" sx={{ paddingTop: "4px" }}>
                    <Grid item sx={{ flex: 1 }}>
                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: labelColor }}>
                            {label}
                        </Typography>
                    </Grid>
                    <Grid item sx={{ width: 152, display: 'flex' }}>
                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: valueColor, textAlign: "center", flex: 1 }}>
                            {fmt(data["1"])}
                        </Typography>
                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: valueColor, textAlign: "center", flex: 1 }}>
                            {fmt(data["X"])}
                        </Typography>
                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: valueColor, textAlign: "center", flex: 1 }}>
                            {fmt(data["2"])}
                        </Typography>
                    </Grid>
                </Grid>
            );
        };

        return (
            <Grid sx={{ padding: "8px 12px 0px", borderBottom: tc.fixtureBorder }}>
                <Grid container sx={{ paddingBottom: "8px", gap: "8px", flexWrap: "nowrap" }}>
                    {/* Game number */}
                    <Grid item sx={{ width: 12, flexShrink: 0, display: "flex", alignItems: "flex-start" }}>
                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: tc.textPrimary, textAlign: "center", fontWeight: 400 }}>
                            {gameNumber}
                        </Typography>
                    </Grid>

                    {/* Content */}
                    <Grid item sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                        {/* Status row */}
                        <Grid container justifyContent="space-between" alignItems="flex-start" sx={{ flexWrap: "nowrap" }}>
                            <Grid item sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: isPlaying ? "#F74640" : tc.textSecondary, fontWeight: 400 }}>
                                    {statusText}
                                </Typography>
                                {isPlaying && (
                                    <Typography sx={{ fontSize: "10px", lineHeight: "14px", color: tc.textSecondary, fontWeight: 400 }}>
                                        {t('started')} {fixtureDate.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}
                                    </Typography>
                                )}
                            </Grid>
                            {(rowsLeftPerGame[gameNumber] || userRowsLeftPerGame[gameNumber]) && (
                                <Grid item sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                    {rowsLeftPerGame[gameNumber] && round.fixtures.some(f => f.status === "PLAYING" || f.status === "FINISHED") && (
                                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: tc.textSecondary, fontWeight: 400, whiteSpace: "nowrap" }}>
                                            {t('number_of_rows_left')}: {formatCount(rowsLeftPerGame[gameNumber].count)} ({rowsLeftPerGame[gameNumber].percent.toFixed(1)}%)
                                        </Typography>
                                    )}
                                    {userRowsLeftPerGame[gameNumber] && (isFinished || isPlaying) && (
                                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: tc.textSecondary, fontWeight: 400, whiteSpace: "nowrap" }}>
                                            {t('my_rows_left')}: {formatUserCount(userRowsLeftPerGame[gameNumber].count)} ({userRowsLeftPerGame[gameNumber].percent.toFixed(1)}%)
                                        </Typography>
                                    )}
                                </Grid>
                            )}
                        </Grid>

                        {/* Teams + Sign boxes */}
                        <Grid container alignItems="center" sx={{ gap: "8px", flexWrap: "nowrap" }}>
                            {/* Team names + scores */}
                            <Grid item sx={{ flex: 1, minWidth: 0 }}>
                                <Grid container justifyContent="space-between" alignItems="center" sx={{ height: 20, flexWrap: "nowrap" }}>
                                    <Typography noWrap sx={{ fontSize: "14px", lineHeight: "20px", color: tc.textPrimary, fontWeight: 400 }}>
                                        {getTeamName(fixture.homeTeam, t)}
                                    </Typography>
                                    {(isFinished || isPlaying) && (
                                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: isPlaying ? "#ff9800" : tc.textPrimary, fontWeight: 400, minWidth: 20, textAlign: "center" }}>
                                            {homeScore}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" sx={{ height: 20, flexWrap: "nowrap" }}>
                                    <Typography noWrap sx={{ fontSize: "14px", lineHeight: "20px", color: tc.textPrimary, fontWeight: 400 }}>
                                        {getTeamName(fixture.awayTeam, t)}
                                    </Typography>
                                    {(isFinished || isPlaying) && (
                                        <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: isPlaying ? "#ff9800" : tc.textPrimary, fontWeight: 400, minWidth: 20, textAlign: "center" }}>
                                            {awayScore}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>

                            {/* Sign boxes */}
                            <Grid item sx={{ display: "flex", gap: "4px", flexShrink: 0 }}>
                                {renderSignBox("ONE")}
                                {renderSignBox("X")}
                                {renderSignBox("TWO")}
                            </Grid>
                        </Grid>

                        {/* Row counts */}
                        {isNextGame && isAfterDeadline && (
                            <>
                                {renderRowCount(t('my_rows_left'), userOutcomeData, tc.textPrimary, tc.textPrimary, formatUserCount)}
                                {renderRowCount(t('number_of_rows_left'), totalOutcomeData, tc.textSecondary, tc.textSecondary)}
                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const lastGameNumber = gameNumbers.length > 0 ? Math.max(...gameNumbers) : 0;
    const lastGameData = numberOfCouponsLeftPerOutcome?.[lastGameNumber];
    const numRowsLeft = (() => {
        // Use the first unfinished game's total rows, or fall back to last game with data
        if (firstUnfinishedGame && numberOfCouponsLeftPerOutcome?.[firstUnfinishedGame]) {
            const data = numberOfCouponsLeftPerOutcome[firstUnfinishedGame];
            return Object.values(data).reduce((sum, count) => sum + count, 0);
        }
        return lastGameData ? Object.values(lastGameData).reduce((sum, count) => sum + count, 0) : 0;
    })();

    const roundName = getRoundName(round, t);
    const ribbonGradient = (window as any).theme === themeC.Wood
        ? gradientsC.Wood.Flex
        : isDbet
            ? gradientsC.Dbet.Flex
            : isLyllo
                ? gradientsC.Lyllo.Flex
                : isKryss
                    ? gradientsC.Kryss.Flex
                    : isGreen
                        ? gradientsC.Green.Flex
                        : isLion
                            ? gradientsC.Lion.Flex
                            : isOrange
                                ? gradientsC.Orange.Flex
                                : isHajper
                                ? gradientsC.Hajper.Flex
                                : isStugan
                                ? gradientsC.Stugan.Flex
                                : isSnabbare
                                ? gradientsC.Snabbare.Flex
                                : gradientsC.GoGo.Flex;
    
    const myStake = couponShare.stake;
    const totalStake = myStake ? formatStringCurrency(myStake.amount, myStake.currency, t, true) : '';

    // Countdown
    const SurvivorCountdown: React.FC = () => {
        const targetTime = new Date(round.openTo).getTime();
        const cutoff = new Date(Date.now());
        cutoff.setHours(cutoff.getHours() + 5);
        const showCountDown = new Date(round.openTo) < cutoff && !isAfterDeadline;

        const [timeLeft, setTimeLeft] = useState(targetTime - Date.now());

        useEffect(() => {
            if (!showCountDown) return;
            const id = setInterval(() => setTimeLeft(targetTime - Date.now()), 1000);
            return () => clearInterval(id);
        }, [targetTime, showCountDown]);

        if (!showCountDown) {
            return (
                <Typography sx={{ fontFamily: tc.fontFamily, fontWeight: isOrange ? 500 : 400, fontSize: '10px', lineHeight: '15px', color: isOrange ? '#FFFFFF' : tc.textOnRibbon }}>
                    {isAfterDeadline ? t('started') : t('starts')} {new Date(round.openTo).toLocaleDateString()}
                </Typography>
            );
        }

        const total = Math.max(0, timeLeft);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));
        const hours = Math.floor(total / (1000 * 60 * 60)) % 24;
        const minutes = Math.floor(total / (1000 * 60)) % 60;
        const seconds = Math.floor(total / 1000) % 60;

        const pillStyle = {
            background: tc.countdownPillBg,
            borderRadius: '9px',
            padding: '3px 6px',
            display: 'inline-flex',
            alignItems: 'center',
        };
        const pillTextColor = (isLion || isOrange) ? '#1F1F1F' : tc.textOnRibbon;
        const labelTextColor = (isOrange || isLion) ? '#FFFFFF' : pillTextColor;
        const textStyle: React.CSSProperties = { fontFamily: tc.fontFamily, fontWeight: (isOrange || isLion || isWood || isHajper) ? 700 : 400, fontSize: '10px', lineHeight: '10px', color: pillTextColor };
        const labelStyle: React.CSSProperties = { fontFamily: tc.fontFamily, fontWeight: 500, fontSize: '10px', lineHeight: '10px', color: labelTextColor };
        const sepStyle: React.CSSProperties = { ...textStyle, color: labelTextColor, padding: '0 1px', fontWeight: 700 };
        const fmt = (n: number) => n.toString().padStart(2, '0');

        return (
            <Grid container alignItems="center" sx={{ gap: "2px", justifyContent: "center" }}>
                {(isOrange || isLion) && (
                    <span style={{ ...labelStyle, padding: '3px', marginRight: '2px' }}>{t('starts')}</span>
                )}
                {days > 0 && (
                    <>
                        <Box sx={pillStyle}><span style={textStyle}>{fmt(days)}d</span></Box>
                        <span style={sepStyle}>,</span>
                    </>
                )}
                <Box sx={pillStyle}><span style={textStyle}>{fmt(hours)}h</span></Box>
                <span style={sepStyle}>:</span>
                <Box sx={pillStyle}><span style={textStyle}>{fmt(minutes)}m</span></Box>
                <span style={sepStyle}>:</span>
                <Box sx={pillStyle}><span style={textStyle}>{fmt(seconds)}s</span></Box>
            </Grid>
        );
    };

    const renderChartCard = (ref: React.RefObject<HTMLDivElement>) => (
        <Grid ref={ref} sx={{
            width: 355,
            maxWidth: 355,
            background: isLion ? '#FFFFFF' : isOrange ? tc.cardBg : tc.chartBorderGradient,
            border: (isLion || isOrangeLight) ? '2px solid #EBEBEB' : isOrange ? '2px solid #575757' : undefined,
            boxShadow: '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
            borderRadius: (isOrange || isLion) ? '8px' : '10px',
            margin: '8px 0',
            padding: (isOrange || isLion) ? '0px' : '2px',
            boxSizing: 'border-box',
        }}>
            <Grid sx={{
                background: tc.cardInnerBg,
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
                <Grid sx={{ padding: '8px 16px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '4px' }}>
                    <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <Typography sx={{ fontFamily: tc.fontFamily, fontSize: '16px', lineHeight: '24px', color: tc.textPrimary, fontWeight: 400 }}>
                            {t('coupon_value_trend')}
                        </Typography>
                        <Typography sx={{ fontFamily: tc.fontFamily, fontSize: '12px', lineHeight: '16px', color: tc.textSecondary }}>
                            {t('stake')} - {totalStake}
                        </Typography>
                    </Grid>
                    {couponShare?.status === 'CASHED_OUT' && (() => {
                        let badgeColor = '#DDB95F';
                        if (isOrange) {
                            badgeColor = '#FE8000';
                        } else if (isLion) {
                            badgeColor = '#FD5C3C';
                        } else if (isDbet) {
                            badgeColor = '#112F7C';
                        } else if (isLyllo) {
                            badgeColor = '#F02884';
                        } else if (isGreen) {
                            badgeColor = '#147B45';
                        } else if (isWood) {
                            badgeColor = '#B19661';
                        } else if (isHajper) {
                            badgeColor = '#A9F7CA';
                        } else if (isKryss) {
                            badgeColor = '#1191D7';
                        } else if ((window as any).theme === themeC.GoGo) {
                            badgeColor = '#F14AA7';
                        } else if (tc.accent) {
                            badgeColor = tc.accent;
                        }

                        return (
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: `1px solid ${badgeColor}`,
                                borderRadius: '4px',
                                padding: '2px 8px',
                            }}>
                                <Typography sx={{ fontFamily: tc.fontFamily, fontSize: '12px', fontWeight: 400, color: badgeColor, lineHeight: '16px' }}>
                                    {t('cashed_out')}
                                </Typography>
                            </Box>
                        );
                    })()}
                </Grid>
                <Grid sx={{
                    padding: '12px 16px',
                    background: tc.chartBg,
                    borderTop: tc.chartTopBorder,
                    borderBottom: tc.chartTopBorder,
                }}>
                    {(() => {
                        const stakeAmount = myStake?.amount ?? 0;
                        const hasData = (isAfterDeadline || anyGameStarted) && Object.keys(couponValuePerGame).length > 0;
                        if (!hasData) {
                            return (
                                <RechartChart
                                    data={[{ game: t('start'), value: stakeAmount }]}
                                    currencyCode={round.operatorTurnover.currency}
                                    showProjections={false}
                                />
                            );
                        }
                        return (
                        <RechartChart
                            data={(() => {
                                const startPoint: { game: string; value?: number; projectedHome?: number; projectedDraw?: number; projectedAway?: number } = {
                                    game: t('start'),
                                    value: stakeAmount,
                                    projectedHome: undefined,
                                    projectedDraw: undefined,
                                    projectedAway: undefined
                                };
                                const finishedGames: Array<{ game: string; value?: number; projectedHome?: number; projectedDraw?: number; projectedAway?: number }> = [
                                    startPoint,
                                    ...gameNumbers
                                    .filter((gameNum) => {
                                        const fixture = round.fixtures[gameNum - 1];
                                        return fixture && fixture.status === "FINISHED";
                                    })
                                    .map((gameNum) => ({
                                        game: `${t('game')} ${gameNum}`,
                                        value: couponValuePerGame[gameNum] || 0,
                                        projectedHome: undefined,
                                        projectedDraw: undefined,
                                        projectedAway: undefined
                                    }))];

                                if (finishedGames.length > 0) {
                                    const lastIdx = finishedGames.length - 1;
                                    const lastVal = finishedGames[lastIdx].value ?? 0;
                                    finishedGames[lastIdx] = {
                                        ...finishedGames[lastIdx],
                                        projectedHome: lastVal,
                                        projectedDraw: lastVal,
                                        projectedAway: lastVal
                                    };
                                }

                                if (firstUnfinishedGame) {
                                    const totalOutcomeData = numberOfCouponsLeftPerOutcome?.[firstUnfinishedGame];
                                    const totalRowsRemaining = totalOutcomeData ? Object.values(totalOutcomeData).reduce((sum, count) => sum + count, 0) : 0;
                                    const userOutcomeData = userRowsPerOutcome[firstUnfinishedGame];
                                    const userRowsRemaining = userOutcomeData ? Object.values(userOutcomeData).reduce((sum, count) => sum + count, 0) : 0;

                                    if (userRowsRemaining <= 0) {
                                        finishedGames.push({
                                            game: `${t('game')} ${firstUnfinishedGame}`,
                                            value: 0,
                                            projectedHome: undefined,
                                            projectedDraw: undefined,
                                            projectedAway: undefined
                                        });
                                        return finishedGames;
                                    }

                                    if (totalRowsRemaining <= 0) return finishedGames;

                                    finishedGames.push({
                                        game: `${t('game')} ${firstUnfinishedGame}`,
                                        value: undefined,
                                        projectedHome: projectedValues["1"],
                                        projectedDraw: projectedValues["X"],
                                        projectedAway: projectedValues["2"]
                                    });
                                }

                                return finishedGames;
                            })()}
                            currencyCode={round.operatorTurnover.currency}
                            showProjections={showProjections}
                        />
                    );
                    })()}
                </Grid>
                {(() => {
                    const cashoutValue = cashout.cashoutValue;
                    const showCashOut = cashout.showCashout;
                    if (!isOrange && !isLion && !showCashOut) return null;
                    if (isOrange || isLion) {
                        return (
                            <Grid sx={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {shareEnabled && (isAfterDeadline || anyGameStarted) && (
                                    <Box
                                        onClick={handleShare}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            padding: '12px 24px',
                                            gap: '8px',
                                            height: '36px',
                                            border: tc.shareButtonBorder,
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            boxSizing: 'border-box',
                                            '&:hover': { borderColor: '#888' },
                                        }}
                                    >
                                        <IosShareIcon sx={{ color: tc.shareButtonIcon, fontSize: 16 }} />
                                        <Typography sx={{ fontFamily: tc.fontFamily, fontWeight: 400, fontSize: '16px', lineHeight: '24px', color: tc.shareButtonText }}>
                                            {t('share')}
                                        </Typography>
                                    </Box>
                                )}
                                {showCashOut && cashoutValue && (
                                    <CashoutButton
                                        value={cashoutValue.value}
                                        disabled={cashout.isCashingOut}
                                        onClick={cashout.requestCashout}
                                        fontFamily={tc.fontFamily}
                                    />
                                )}
                            </Grid>
                        );
                    }
                    return (
                        <Grid sx={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <CashoutButton
                                value={cashoutValue!.value}
                                disabled={cashout.isCashingOut}
                                onClick={cashout.requestCashout}
                                fontFamily={tc.fontFamily}
                            />
                        </Grid>
                    );
                })()}
            </Grid>
        </Grid>
    );

    return (
        <Grid container direction="column" alignItems="center" sx={{ background: tc.pageBg, width: '100%' }}>
          <Grid container direction="column" alignItems="center" sx={{ background: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? '#FFFFFF' : 'transparent', width: '100%', maxWidth: (isGreen || isKryss || isLyllo || isDbet || isOrange || isLion || isWood || isHajper || isStugan || isSnabbare || isHard) ? 355 : undefined, borderRadius: (isKryss || isLyllo) ? '12px' : (isDbet || isStugan || isSnabbare) ? '10px' : (isOrange || isLion || isWood || isHajper || isHard) ? '8px' : undefined, boxShadow: (isOrange || isLion || isWood || isHajper || isHard) ? '0px 1px 13px -2px rgba(16, 24, 40, 0.08)' : undefined }}>
            <Grid container direction="column" alignItems="center" sx={{ background: isWood ? '#1E1E1E' : 'transparent', width: '100%', borderRadius: isWood ? '8px' : undefined, overflow: isWood ? 'hidden' : undefined }}>
            {/* Ribbon tag */}
            <Grid sx={{
                width: '100%',
                maxWidth: 355,
                backgroundImage: isGreen ? `url(${unibet_football})` : isHajper ? `url(${hajper8})` : isWood ? `url(${woodRocket})` : isOrange ? `url(${orangeRocket})` : isLion ? `url(${lionRocket})` : isStugan ? `url(${stuganBackground})` : isSnabbare ? `url(${snabbareSurvivorBg})` : isHard ? `url(${hardSurvivor})` : ribbonGradient,
                backgroundSize: (isWood || isOrange || isLion) ? '100% auto' : 'cover',
                backgroundRepeat: (isWood || isOrange || isLion) ? 'no-repeat' : undefined,
                backgroundPosition: isGreen ? 'center 64%' : (isHajper || isHard) ? 'center' : (isWood || isOrange || isLion) ? 'right bottom' : undefined,
                borderRadius: (isKryss || isLyllo) ? '12px 12px 0px 0px' : (isDbet || isStugan || isSnabbare) ? '10px 10px 0px 0px' : '8px 8px 0px 0px',
                padding: isGreen ? '0px' : '12px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                position: 'relative',
                minHeight: isGreen ? '100px' : isHard ? '104px' : undefined,
            }}>
                {isGreen && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'linear-gradient(180deg, rgba(14, 60, 22, 0.5) 30%, rgba(62, 171, 55, 0.5) 100%)',
                        borderRadius: '8px 8px 0px 0px',
                    }} />
                )}
                {isGreen && (
                    <Box sx={{ position: 'absolute', top: 8, left: 8, zIndex: 1 }}>
                        <Unibet1x2TileLogo width={32} height={19} />
                    </Box>
                )}
                <Box sx={{
                    position: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'relative' : undefined,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? '4px' : '8px',
                    width: '100%',
                    height: isGreen ? '100px' : undefined,
                    padding: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? '12px' : undefined,
                    boxSizing: 'border-box',
                }}>
                    {/* Ribbon text reads tc.textOnRibbon (not hardcoded white): Kryss/Lyllo/Dbet stay #FFFFFF, Stugan renders its text pink. If the previous hardcoded #FFFFFF was an intentional force-white override, revert to color: isStugan ? tc.textOnRibbon : '#FFFFFF' (keeps Stugan's pink). */}
                    {isDbet ? (
                        <>
                            <Typography sx={{
                                fontFamily: 'Righteous',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '24px',
                                color: '#F4C004',
                                textTransform: 'uppercase',
                            }}>
                                {t('survivor8')}
                            </Typography>
                            <Grid container direction="row" alignItems="center" justifyContent="center">
                                <Grid sx={{ marginRight: "10px" }}>
                                    {GetFlexNumber(round.name) === "6" ? DbetSixIcon() : DbetEightIcon()}
                                </Grid>
                                {DbetEightLadder()}
                            </Grid>
                        </>
                    ) : isSnabbare ? (
                        <>
                            {/* Snabbare survivor lockup — keep in sync with survivorround.tsx. */}
                            <Typography sx={{
                                fontFamily: 'var(--font-title)',
                                fontWeight: 'var(--font-title-weight)',
                                fontSize: '52px',
                                lineHeight: '52px',
                                letterSpacing: '-0.01em',
                                color: tc.textOnRibbon,
                                textTransform: 'uppercase',
                                fontStyle: 'normal'
                            }}>
                                {GetFlexNumber(round.name)}
                            </Typography>
                            <Typography sx={{
                                fontFamily: 'var(--font-body)',
                                fontWeight: 700,
                                fontSize: '14px',
                                lineHeight: '18px',
                                letterSpacing: '0.34em',   // wide tracking to match the brand wordmark
                                textIndent: '0.34em',       // balance the trailing space so it stays centered
                                color: tc.textOnRibbon,
                                textTransform: 'uppercase',
                                fontStyle: 'normal'
                            }}>
                                {t('survivor8')}
                            </Typography>
                        </>
                    ) : isStugan ? (
                        <>
                            {/* Stugan survivor lockup — keep in sync with survivorround.tsx. */}
                            <Typography sx={{
                                fontFamily: 'var(--font-title)',
                                fontWeight: 'var(--font-title-weight)',
                                fontSize: '40px',
                                lineHeight: '40px',
                                color: tc.textOnRibbon,
                                
                            }}>
                                {GetFlexNumber(round.name)}
                            </Typography>
                            <Typography sx={{
                                fontFamily: 'var(--font-body)',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '20px',
                                letterSpacing: '0.05em',
                                color: '#FDA89B',
                            }}>
                                {t('survivor8')}
                            </Typography>
                        </>
                    ) : (isKryss || isLyllo) ? (
                        <>
                            <Typography sx={{
                                fontFamily: 'var(--font-title)',
                                fontWeight: 'var(--font-title-weight)',
                                fontSize: '40px',
                                lineHeight: '40px',
                                color: tc.textOnRibbon,
                                textTransform: 'uppercase',
                            }}>
                                {GetFlexNumber(round.name)}
                            </Typography>
                            <Typography sx={{
                                fontFamily: 'var(--font-body)',
                                fontWeight: 700,
                                fontSize: '16px',
                                lineHeight: '20px',
                                color: tc.textOnRibbon,
                                textTransform: 'uppercase',
                            }}>
                                {t('survivor8')}
                            </Typography>
                        </>
                    ) : isGreen ? (
                        <>
                            <Typography sx={{
                                fontFamily: 'UnibetPro',
                                fontWeight: 500,
                                fontSize: '52px',
                                lineHeight: '40px',
                                color: '#FFFFFF',
                            }}>
                                {GetFlexNumber(round.name)}
                            </Typography>
                            <Typography sx={{
                                fontFamily: 'UnibetPro',
                                fontWeight: 500,
                                fontSize: '16px',
                                lineHeight: '20px',
                                color: '#FFFFFF',
                                textTransform: 'uppercase',
                            }}>
                                {t('survivor8')}
                            </Typography>
                        </>
                    ) : isHajper ? (
                        <>
                            <Typography sx={{
                                fontFamily: "'HajperDisplay', sans-serif",
                                fontWeight: 800,
                                fontSize: '52px',
                                lineHeight: '52px',
                                color: '#FFFFFF',
                            }}>
                                {GetFlexNumber(round.name)}
                            </Typography>
                            <Typography sx={{
                                fontFamily: "var(--font-title), sans-serif",
                                fontWeight: 500,
                                fontSize: '16px',
                                lineHeight: '20px',
                                color: '#FFFFFF',
                            }}>
                                {t('survivor8')}
                            </Typography>
                            <SurvivorCountdown />
                        </>
                    ) : (
                        <>
                            {/* Hard: "Tipsraketen" is baked into the plate, so no live round name. */}
                            {!isHard && (
                                <Typography sx={{
                                    fontFamily: tc.fontFamily,
                                    fontWeight: (isOrange || isWood || isHajper) ? 700 : 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: isOrange ? '#FFFFFF' : tc.textOnRibbon,
                                    textTransform: 'uppercase',
                                }}>
                                    {roundName}
                                </Typography>
                            )}
                            <SurvivorCountdown />
                        </>
                    )}
                </Box>
            </Grid>

            {/* Scoreboard - Number of rows */}
            <Grid container direction='column' alignItems='center' sx={{
                width: '100%',
                maxWidth: 355,
                background: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--background_4)' : (isLion || isOrangeLight) ? '#F6F6F6' : tc.cardBg,
                padding: '10px',
            }}>
                {(isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) && !isAfterDeadline && (
                    <Grid item>
                        <Grid container direction='column' alignItems='center' sx={{ marginTop: '10px', marginBottom: '0px' }}>
                            <Typography sx={{ fontSize: '12px', color: 'var(--font-color-supportive)', lineHeight: '18px', fontWeight: 400, fontFamily: 'var(--font-body)' }}>
                                {t('starts')}
                            </Typography>
                            <Typography sx={{ fontSize: '16px', color: 'var(--text-black)', lineHeight: '24px', fontWeight: 700, fontFamily: 'var(--font-body)' }}>
                                {new Date(round.openTo).toLocaleDateString()}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                {(isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) && isAfterDeadline && (
                    <Grid item>
                        <Grid container direction='column' alignItems='center' sx={{ marginTop: '10px', marginBottom: '0px' }}>
                            <Typography sx={{ fontSize: '12px', color: 'var(--font-color-supportive)', lineHeight: '18px', fontWeight: 400, fontFamily: 'var(--font-body)' }}>
                                {t('status')}
                            </Typography>
                            <Typography sx={{ fontSize: '16px', color: 'var(--text-black)', lineHeight: '24px', fontWeight: 700, fontFamily: 'var(--font-body)' }}>
                                {round.status === 'ACTIVE' ? 'Live' : round.status}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                <Grid container justifyContent='space-evenly' sx={{ marginTop: '5px' }}>
                    <Grid item>
                        <Grid container direction='column' alignItems='center'>
                            <Typography sx={{ fontSize: '12px', color: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-color-supportive)' : tc.textSecondary, lineHeight: '18px', fontWeight: 400, fontFamily: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-body)' : tc.fontFamily }}>
                                {t('number_of_rows')}
                            </Typography>
                            <Typography sx={{ fontSize: '16px', color: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--text-black)' : tc.textPrimary, lineHeight: '24px', fontWeight: 700, fontFamily: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-body)' : tc.fontFamily }}>
                                {formatCount(numRows)}
                            </Typography>
                        </Grid>
                    </Grid>
                    {isAfterDeadline && (
                        <Grid item>
                            <Grid container direction='column' alignItems='center'>
                                <Typography sx={{ fontSize: '12px', color: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-color-supportive)' : tc.textSecondary, lineHeight: '18px', fontWeight: 400, fontFamily: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-body)' : tc.fontFamily }}>
                                    {t('number_of_rows_left')}
                                </Typography>
                                <Typography sx={{ fontSize: '16px', color: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--text-black)' : tc.textPrimary, lineHeight: '24px', fontWeight: 700, fontFamily: (isGreen || isKryss || isLyllo || isDbet || isStugan || isSnabbare) ? 'var(--font-body)' : tc.fontFamily }}>
                                    {formatCount(numRowsLeft)}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>

            {/* My Bets Card */}
            {renderChartCard(chartCardRef)}

            {/* Hidden off-screen copy for image capture */}
            {(isAfterDeadline || anyGameStarted) && (
                <div style={{ position: 'fixed', left: -9999, top: 0, zIndex: -1, pointerEvents: 'none' }}>
                    {isGoGo ? (
                        <div
                            ref={captureWrapperRef}
                            style={{
                                width: 393,
                                height: 360,
                                background: 'linear-gradient(180deg, rgba(241, 74, 167, 0.8) 0%, rgba(241, 74, 167, 0.32) 50%, rgba(241, 74, 167, 0.16) 100%), #000000',
                                boxShadow: '0px 11.6444px 14.5556px -4.36667px rgba(0, 0, 0, 0.25)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '12px 0',
                                gap: 12,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <GoGoLogo />
                            <div style={{ width: 355 }}>
                                {renderChartCard(captureRef)}
                            </div>
                        </div>
                    ) : isWood ? (
                        <div
                            ref={captureWrapperRef}
                            style={{
                                width: 393,
                                height: 360,
                                background: 'linear-gradient(180deg, rgba(177, 150, 97, 0.8) 0%, rgba(177, 150, 97, 0.32) 50%, rgba(177, 150, 97, 0.16) 100%), #000000',
                                boxShadow: '0px 11.6444px 14.5556px -4.36667px rgba(0, 0, 0, 0.25)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '12px 0',
                                gap: 12,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <WoodLogo />
                            <div style={{ width: 355 }}>
                                {renderChartCard(captureRef)}
                            </div>
                        </div>
                    ) : isLion ? (
                        <div
                            ref={captureWrapperRef}
                            style={{
                                width: 393,
                                height: 360,
                                background: 'linear-gradient(180deg, #EF4701 0%, #FD6301 100%)',
                                boxShadow: '0px 11.6444px 14.5556px -4.36667px rgba(0, 0, 0, 0.25)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '12px 0',
                                gap: 12,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <LeoVegasLogo />
                            <div style={{ width: 355 }}>
                                {renderChartCard(captureRef)}
                            </div>
                        </div>
                    ) : isOrange ? (
                        <div
                            ref={captureWrapperRef}
                            style={{
                                width: 393,
                                height: 360,
                                background: 'linear-gradient(180deg, #FE8000 0%, #FE9326 100%)',
                                boxShadow: '0px 11.6444px 14.5556px -4.36667px rgba(0, 0, 0, 0.25)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '12px 0',
                                gap: 12,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <ExpektLogo />
                            <div style={{ width: 355 }}>
                                {renderChartCard(captureRef)}
                            </div>
                        </div>
                    ) : (
                        <div style={{ width: 355 }}>
                            {renderChartCard(captureRef)}
                        </div>
                    )}
                </div>
            )}

            {/* Share button - outside captured area */}
            {shareEnabled && !isOrange && !isLion && (isAfterDeadline || anyGameStarted) && (
                <Box
                    onClick={handleShare}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '6px 24px',
                        gap: '8px',
                        height: '28px',
                        width: '100%',
                        maxWidth: 355,
                        border: tc.shareButtonBorder,
                        borderRadius: '6px',
                        cursor: 'pointer',
                        marginTop: '8px',
                        boxSizing: 'border-box',
                        '&:hover': { borderColor: '#888' },
                    }}
                >
                    <IosShareIcon sx={{ color: tc.shareButtonIcon, fontSize: 16 }} />
                    <Typography sx={{ fontFamily: tc.fontFamily, fontWeight: 400, fontSize: '16px', lineHeight: '24px', color: tc.shareButtonText }}>
                        {t('share')}
                    </Typography>
                </Box>
            )}

            {/* ShareDialog */}
            {showShareDialog && publicUrl && (
                <ShareDialog publicUrl={publicUrl} open={showShareDialog} onClose={() => setShowShareDialog(false)} />
            )}

            {/* Cashout Confirmation Dialog */}
            <CashoutConfirmDialog
                open={cashout.showConfirm}
                value={cashout.cashoutValue?.value}
                onClose={cashout.closeConfirm}
                onConfirm={cashout.confirmCashout}
            />

            {/* Cashout Result Dialog */}
            <CashoutResultDialog
                result={cashout.result}
                onClose={cashout.closeResult}
            />

            {/* Games section */}
            <Grid sx={{
                width: '100%',
                maxWidth: 355,
                paddingTop: '12px',
                background: isLion ? '#FFFFFF' : isOrange ? tc.cardBg : undefined,
            }}>
                {round.fixtures.map((fixture, idx) => (
                    <SurvivorFixture key={fixture.id} fixture={fixture} index={idx} />
                ))}
            </Grid>

            {/* Payout Plan */}
            {isAfterDeadline && round.fixtures.every(f => f.status === "FINISHED") && (
                <Grid sx={{
                    width: '100%',
                    maxWidth: 355,
                    background: tc.cardBg,
                    borderRadius: '8px',
                    margin: '24px auto 8px',
                    alignSelf: 'center',
                    overflow: 'hidden',
                    '& table': {
                        width: '100%',
                        tableLayout: 'fixed',
                    },
                    '& th, & td': {
                        fontSize: '10px !important',
                        padding: '5px 6px !important',
                        color: `${tc.textPrimary} !important`,
                        backgroundColor: 'transparent !important',
                        fontFamily: `${tc.fontFamily} !important`,
                        borderBottom: `1px solid ${tc.tableBorderColor}`,
                    },
                    '& thead': {
                        background: `${tc.tableHeaderBg} !important`,
                    },
                    '& thead th': {
                        color: `${tc.textSecondary} !important`,
                        fontWeight: '600 !important',
                    },
                    '& tbody': {
                        background: `${tc.tableBodyBg} !important`,
                    },
                    '& tfoot': {
                        background: `${tc.tableHeaderBg} !important`,
                    },
                    '& tfoot td': {
                        fontWeight: '600 !important',
                    },
                }}>
                    <WinInfo round={round} couponShare={couponShare} isRightToLeft={IsRightToLeftTheme((window as any).theme)} />
                </Grid>
            )}
            <Grid sx={{ height: '24px' }} />
            </Grid>
          </Grid>
        </Grid>
    );
};

export default SurvivorCoupon;
